<template>
    <div id="AddressDiv">
        <HeaderVue step="true" tab='patient'/>
        <div class="portal-section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="alert alert-dark" role="alert">
                            Patient Details
                            <span class="float-right blue-color  cursor-pointer" v-on:click="addMember()">
                                <span class="badge add-badge badge-light float-left">
                                    <i class="material-icons">add</i>
                                </span>
                                <span class="hide-ipad">
                                  Add New
                                </span>
                            </span>
                        </div>
                        <ul class="patient-list mt-4" v-if="members">
                            <li v-if="members.user" :class="{'selected-address' : (members.user.userId === isMemberActiveId && isMe === true)}">
                                <div class="row">
                                    <div class="col-8" v-on:click="isMemberActiveId = members.user.userId; setActiveMemberId(members.user)">
                                        <i class="material-icons">check_circle</i>
                                    </div>
                                    <div class="col-2">
                                        <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editMemberProfile(1)">
                                            <img src="static/images/pen-blue.svg" alt="">
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <p class="mt-2 mb-0">{{members.user.firstName + ' ' + members.user.lastName}}</p>
                                        <p class="mb-0" v-if="members.user.age || (members.user.sex && members.user.sex.length > 0) ">{{members.user.age}}, {{(members.user.sex==='O'?'Other':((members.user.sex==='M')?'Male':((members.user.sex==='F')?'Female':'')))}}</p>
                                        <p v-if="members.user.mobile">M: {{members.user.mobile}}</p>
                                    </div>
                                </div>
                            </li>
                            <li v-for="(family, index) in members.family" :class="{'selected-address' : (family.memberId === isMemberActiveId && isMe === false)}" v-bind:key="index">
                                <div class="row">
                                    <div class="col-8" v-on:click="isMemberActiveId = family.memberId; setActiveMemberId(family)">
                                        <i class="material-icons">check_circle</i>
                                    </div>
                                    <div class="col-2">
                                        <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editMember(family)">
                                            <img src="static/images/pen-blue.svg" alt="">
                                        </button>
                                    </div>
                                    <div class="col-2" v-if="(family.memberId !== isMemberActiveId || isMe)" v-on:click="deleteMember(family)">
                                        <button class="btn btn-link remove-btn p-0">
                                            <img src="static/images/close-black.svg" alt="">  
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <p class="mt-2 mb-0">{{family.firstName + ' ' + family.lastName}}</p>
                                        <p class="mb-0" v-if="family.age || (family.sex && family.sex.length > 0) ">{{family.age}}, {{(family.sex==='O'?'Other':((family.sex==='M')?'Male':((family.sex==='F')?'Female':'')))}}</p>
                                        <p v-if="family.mobile">M: {{family.mobile}}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-4">
                        <div class="alert alert-dark" role="alert">
                            Pickup Address
                            <span class="float-right blue-color cursor-pointer" v-on:click="addAddress()">
                                <span class="badge add-badge badge-light float-left">
                                    <i class="material-icons">add</i>
                                </span>
                                <span class="hide-ipad">
                                  Add New
                                </span>
                            </span>
                        </div>
                        <ul class="patient-list mt-4" v-if="addresses">
                            <li v-for="(address, index) in addresses" :key="index" :class="{'selected-address' : (address.addressId === isAddressActiveId)}">
                                <div class="row">
                                    <div class="col-8" v-on:click="selectAddress(address)">
                                        <i class="material-icons">check_circle</i>
                                    </div>
                                    <div class="col-2">
                                        <button class="btn btn-link edit-btn p-0 float-right" v-on:click="editAddress(address) ">
                                            <img src="static/images/pen-blue.svg" alt="">
                                        </button>
                                    </div>
                                    <div class="col-2" v-on:click="deleteAddress(address.addressId)" v-if="(address.addressId !== isAddressActiveId)">
                                        <button class="btn btn-link remove-btn p-0">
                                            <img src="static/images/close-black.svg" alt="">
                                        </button>
                                    </div>
                                </div>
                                <div class="row" >
                                    <div class="col-sm-12" >
                                        <address class="mt-2">
                                            {{address.flatNo ? address.flatNo +', ' : '' }} {{address.address}}, {{address.landmark ? address.landmark +', ' : '' }} {{address.Location.locationName}}, <br />{{address.City.cityName}} - {{address.zipCode}}. 
                                        </address>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-4">
                        <form data-vv-scope="coupon" @submit.prevent="applyCoupon()">
                          <div class="input-group mt-0" v-if="!isCouponApplied">
                              <input type="text" class="form-control text-uppercase" name="couponCode" data-vv-as="coupon code" v-model="couponCode" v-on:keyup="couponError='';" v-validate="'required|max:25'" placeholder="Coupon code" aria-label="Coupon code">
                              <span class="input-group-btn">
                                  <button class="btn btn-link" type="button" @click.prevent="applyCoupon()">Apply</button>
                              </span>
                          </div>
                          <span v-show="errors.has('coupon.couponCode')" class="text-danger">{{ errors.first('coupon.couponCode') }}</span>
                          <span v-show="!errors.has('coupon.couponCode') && couponError && !isSuccessCoupon" v-bind:class="{'text-danger': !isSuccessCoupon,'green-color': isSuccessCoupon}">{{ couponError }}</span>
                        </form>
                        <div class="input-group mt-0" v-if="isCouponApplied && couponData">
                            <div class="alert alert-success applied-coupon w-100">
                                <button type="button" class="close close-circle" v-on:click="removeCoupon()">
                                    <span >×</span>
                                </button>
                                <h6 class="text-center alert-heading mb-0">Applied Coupon :  <b>{{couponData.coupon_code}} </b></h6>
                                <hr class="mt-2 mb-2">
                                <p class="text-center mb-0">{{couponError}} reduced on your order value.</p>
                            </div>
                        </div>
                        <div id="accordion" class="mt-3" role="tablist" v-if="payinfo.creditPoints && payinfo.creditPoints > 0">
                          <div class="card p-3">
                            <span class="ml-4 green-color">Labotist Credits Available = {{payinfo.creditPoints}}</span>
                            <label class="checkbox_container">
                              <input type="checkbox" ref="redeemCredits"  name="redeemCredits" id="redeemCredits" data-vv-as="redeemCredits" v-model="redeemCredits" v-on:change="termsConditionError=false">
                              <span class="checkbox_checkmark"></span>
                            </label>
                            <span class="ml-4">I would like to use my Labotist Credits towards this purchase.</span>
                          </div>
                        </div>
                        <div id="accordion" class="mt-3" role="tablist">
                          <div class="card">
                                <div class="card-header" role="tab" id="headingOne">
                                    <h5 class="pb-2 mb-0 border-bottom">
                                        <a data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="black-color collapsed">
                                            Test Details
                                            <i class="material-icons float-right"></i>
                                        </a>
                                    </h5>
                                </div>
                                <div id="collapseOne" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#sideBar">
                                    <div class="card-body pb-0 pt-0">
                                        <div class="table-responsive">
                                            <table class="table price-table">
                                                <tr>
                                                    <td class="border-bottom" colspan="2"> 
                                                      <span class="black-color">{{$localStorage.get('sl').labName}}</span><br>
                                                      <span class="">{{$localStorage.get('sl').branch.branchLocation + ', ' + $localStorage.get('sl').branch.branchCity + '-' + $localStorage.get('sl').branch.branchZipCode}}</span>
                                                    </td>
                                                </tr>
                                                <tr v-for="(cost, index) in testCosts.priceDetails" :key="index">
                                                    <td class="black-color border-bottom">{{cost.aliasName}}</td>
                                                    <td class="text-right black-color border-bottom">
                                                      Rs. {{cost.ourPrice}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div id="collapseTwo" class="collapse show" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body pb-0 pt-0">
                                        <div class="table-responsive">
                                            <table class="table price-table">
                                                <tr>
                                                    <td>Order Value</td>
                                                    <td class="text-right">
                                                      <h5 class="float-right mt-1 mb-0 price-tags">
                                                          <span class="red-color strip-text" v-if='payinfo.mrpTotal > payinfo.total'>Rs. {{payinfo.mrpTotal}}</span> Rs. {{payinfo.total}}
                                                      </h5>
                                                    </td>
                                                </tr>
                                                 <tr v-if="payinfo.couponFee > 0">
                                                    <td>Coupon Discount</td>
                                                    <td class="text-right green-color">- Rs. {{payinfo.couponFee}}</td>
                                                </tr>
                                                <tr v-if="payinfo.mrpTotal != payinfo.subTotal" class="black-color">
                                                    <td>Sub Total</td>
                                                    <td class="text-right">Rs. {{payinfo.total - payinfo.couponFee}}</td>
                                                </tr>
                                                <tr v-if="payinfo.phlebotomistFee > 0" class="black-color">
                                                    <td>Phlebotomist Fee
                                                       <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="top" v-bind:title="'This price is applicable when the order value is below Rs.'+payinfo.waiverDiscountApplyFee">
                                                        </i>
                                                    </td>
                                                    <td class="text-right">Rs. {{payinfo.phlebotomistFee}}</td>
                                                    
                                                </tr>
                                               
                                                <tr v-if="redeemCreditPoints > 0">
                                                    <td>Credits Applied</td>
                                                    <td class="text-right green-color">- Rs. {{redeemCreditPoints}}</td>
                                                </tr>
                                                <tr v-if="payinfo.phlebotomyFeeWaiver > 0" class="black-color">
                                                    <td>Coupon Discount</td>
                                                    <td class="text-right green-color">-Rs. {{payinfo.phlebotomyFeeWaiver}}</td>
                                                </tr>
                                                <tr class="black-color">
                                                    <td>Amount Payable</td>
                                                    <td>
                                                      <h5 class="float-right mt-1 mb-0 price-tags">
                                                            <span class="red-color strip-text" v-if='payinfo.mrpTotal > payinfo.total'>Rs. {{payinfo.grandTotalStrike}}</span> Rs. {{payinfo.grandTotal-redeemCreditPoints}}
                                                      </h5>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="accordion" class="mt-3" role="tablist" v-if="$cashPayment && (payinfo.grandTotal - redeemCreditPoints) > 0">
                          <div class="card">
                            <div class="card-header" role="tab" id="headingOne">
                                <h5 class="pb-2 mb-0 border-bottom fs-14 black-color">
                                  Choose Payment Option
                                </h5>
                            </div>
                            <div class="pl-3 pb-3">
                              <label class="checkbox_container mr-5">Online
                                <input type="radio" ref="paymentType"  name="paymentType" id="paymentType" data-vv-as="paymentType" value="1" v-model="paymentType">
                                <span class="checkbox_checkmark"></span>
                              </label>
                              <label class="checkbox_container">Cash
                                <input type="radio" ref="paymentType"  name="paymentType" id="paymentType" data-vv-as="paymentType" value="2" v-model="paymentType">
                                <span class="checkbox_checkmark"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div id="accordion" class="mt-3" role="tablist">
                          <div class="card p-3">
                            <label class="checkbox_container">
                              <input type="checkbox" ref="termsCondition"  name="termsCondition" id="termsCondition" data-vv-as="termsCondition" v-model="termsCondition" v-on:change="termsConditionError=false">
                              <span class="checkbox_checkmark"></span>
                            </label>
                            <span class="ml-4">I have read and agree to the Labotist <span class="termsCondition" v-on:click="termsConditionChanged(2)">Terms of Service</span> and <span class="termsCondition" v-on:click="termsConditionChanged(3)">Privacy Policy</span>?</span>
                            <span class="text-danger fs-12" v-if="termsConditionError">Please agree terms & condition to complete payment</span>
                          </div>
                        </div>
                        <button class="btn btn-primary full-width mt-4" v-if="(payinfo.grandTotal - redeemCreditPoints) > 0" @click.prevent.self="goPayment()">{{paymentType == 2 ? 'Complete Request' : ('Pay Rs.'+(payinfo.grandTotal - redeemCreditPoints))}}</button>
                        <button class="btn btn-primary full-width mt-4" v-if="(payinfo.grandTotal - redeemCreditPoints) == 0" @click.prevent.self="goPayment(true)">Complete Request</button>
                        <!--- The below two lines of statement edited by Aug 19, 2019 to disable pay button. Reason: reported from JP and Srini. The above two commented lines are the original code of this statement -->
                        <!-- <button class="btn btn-primary full-width mt-4" v-if="(payinfo.grandTotal - redeemCreditPoints) > 0" disabled="disabled">{{paymentType == 2 ? 'Complete Request' : ('Pay Rs.'+(payinfo.grandTotal - redeemCreditPoints))}}</button>
                        <button class="btn btn-primary full-width mt-4" v-if="(payinfo.grandTotal - redeemCreditPoints) == 0" disabled="disabled">Complete Request</button> -->
                        <!-- end -->
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
        <div class="modal fade bd-example-modal-lg" id="addAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add Address</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <form data-vv-scope="addAddress">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="clearfix line-textbox">
                                <div class="form-group" v-show="false">
                                    <label>Full name</label>
                                    <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="addAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                                    <span v-show="errors.has('addAddress.fullName')" class="text-danger">{{ errors.first('addAddress.fullName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Flat No, Floor and Apt Name</label>
                                    <input type="text" class="form-control" name="flatNo" id="flatNo" data-vv-as="flatNo" v-model="addAddressFields.flatNo" maxlength="500" v-validate="'required'" />
                                    <small>Ex : 3/123, 2nd Floor, XXXX apt</small><br/>
                                    <span v-show="errors.has('addAddress.flatNo')" class="text-danger">Flat No, Floor and Apt Name is required.</span>
                                </div>
                                <div class="form-group">
                                    <label>Street Address</label>
                                    <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="addAddressFields.address" v-on:blur="addressChanged(1)" v-validate="'required'" />
                                    <span v-show="errors.has('addAddress.address')" class="text-danger">{{ errors.first('addAddress.address') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Landmark <span class="locality-message">(Optional)</span></label>
                                    <input type="text" class="form-control" name="landmark" id="landmark" data-vv-as="landmark" v-model="addAddressFields.landmark" maxlength="300" />
                                    <span v-show="errors.has('addAddress.landmark')" class="text-danger">{{ errors.first('addAddress.landmark') }}</span>
                                </div>
                                <div class="form-group address-locality-search">
                                      <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeAdd"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="addAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(2)"
                                        v-on:keyup.enter="searchLocality(2)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeAdd.select();searchtext=''" 
                                        v-validate="'required'">
                                      <span v-show="errors.has('addAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                                      <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                                      <div class="test-option full-width scrollbar locality" v-bind:style="{ display: onBlurKey}">
                                        <div class="popular-test focus-search p-0">
                                            <ul class="p-0 m-0">
                                                <li class="p-2" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 2)">
                                                    {{item.locationName+'-'+item.locationZipCode}}
                                                </li>
                                                <li v-if="locationList.length === 0" class="p-2 color-blue text-center" v-on:click.self="selectLocation($event, undefined, 3)">
                                                    Other
                                                </li>
                                                <li v-if="locationList.length !== 0" class="p-2 color-blue " v-on:click.self="selectLocation($event, undefined, 3)">
                                                    Other
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                  </div>
                                  
                                <div class="form-group" v-if="showLocOther">
                                      <label>New Pincode</label>
                                      <input type="text" class="form-control" name="locationPincode" id="locationPincode" v-model="addAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(1)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                                      <span v-show="errors.has('addAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                                  </div>
                                <div class="form-group" v-if="showLocOther">
                                    <label>New Location</label>
                                    <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="addAddressFields.locationOther" v-on:blur="addressChanged(1)" v-validate="'required'"/>
                                    <span v-show="errors.has('addAddress.locationOther')" class="text-danger">The Location field is required.</span>
                                </div>
                                <div class="form-group">
                                    <p class="black-color"><span>{{stateCityDisp}}</span></p>
                                </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div id="myMapAdd"  style="width:100%;height:200px;background:#ccc"></div>
                          </div>
                        </div>
                        <div class="row mmt-3">
                              <div class="col-sm-6">
                                    <a class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</a>
                                </div>
                                <div class="col-sm-6">
                                    <button class="btn btn-primary full-width" type="button" v-on:click="saveAddress()">Save</button>
                                </div>
                          </div>
                      </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bd-example-modal-lg" id="editAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Address</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form data-vv-scope="editAddress">
                          <div class="row">
                            <div class="col-sm-12">
                                <div class="clearfix line-textbox">
                                  <div class="form-group" v-show="false">
                                      <label>Full name</label>
                                      <input type="text" class="form-control" name="fullName" id="fullName" maxlength="100" data-vv-as="full name" v-model="editAddressFields.addressName" v-validate="'required|alpha_spaces'" />
                                      <span v-show="errors.has('editAddress.fullName')" class="text-danger">{{ errors.first('editAddress.fullName') }}</span>
                                  </div>
                                  <div class="form-group">
                                      <label>Flat No, Floor and Apt Name</label>
                                      <input type="text" class="form-control" name="flatNo" id="flatNo" data-vv-as="flatNo" v-model="editAddressFields.flatNo" v-on:blur="addressChanged(2)" v-validate="'required'" />
                                      <small>Ex : 3/123, 2nd Floor, XXXX apt</small><br/>
                                      <span v-show="errors.has('editAddress.flatNo')" class="text-danger">Flat No, Floor and Apt Name is required.</span>
                                  </div>
                                  <div class="form-group">
                                      <label>Street Address</label>
                                      <input type="text" class="form-control" name="address" id="address" data-vv-as="address" v-model="editAddressFields.address" v-on:blur="addressChanged(2)" v-validate="'required'" />
                                      <span v-show="errors.has('editAddress.address')" class="text-danger">{{ errors.first('editAddress.address') }}</span>
                                  </div>
                                  <div class="form-group">
                                      <label>Landmark <span class="locality-message">(Optional)</span></label>
                                      <input type="text" class="form-control" name="landmark" id="landmark" data-vv-as="landmark" v-model="editAddressFields.landmark" v-on:blur="addressChanged(2)" />
                                      <span v-show="errors.has('editAddress.landmark')" class="text-danger">{{ errors.first('editAddress.landmark') }}</span>
                                  </div>
                                  <div class="form-group address-locality-search">
                                      <label>Location / Pincode <span class="locality-message">(Choose nearest if exact match not available)</span></label>
                                      <input type="text" class="form-control" name="zipcode" id="zipcode" data-vv-as="zipcode" 
                                        ref="pincodeEdit"
                                        aria-label=""  
                                        list="mycarousel" 
                                        autocomplete="off" 
                                        minlength="3" 
                                        v-model="editAddressFields.zipcode" 
                                        v-on:keyup="searchLocality(1)"
                                        v-on:keyup.enter="searchLocality(1)" 
                                        v-on:blur="closeBlock()"
                                        v-on:focus="$refs.pincodeEdit.select();searchtext=''" 
                                        v-validate="'required'">
                                      <span v-show="errors.has('editAddress.zipcode')" class="text-danger">The Locality/Pincode field is required</span>
                                      <span v-show="isInvalidPincode" class="text-danger">Please choose Locality/Pincode</span>
                                      <div class="test-option full-width scrollbar locality" v-bind:style="{ display: onBlurKey}">
                                        <div class="popular-test focus-search p-0">
                                            <ul class="p-0 m-0">
                                                <li class="p-2" v-for="(item, index) in locationList" :key="index" v-on:click.self="selectLocation($event, item, 1)">
                                                    {{item.locationName+'-'+item.locationZipCode}}
                                                </li>
                                                <li v-if="locationList.length === 0" class="p-2 color-blue text-center" v-on:click.self="selectLocation($event, undefined, 3)">
                                                    Other
                                                </li>
                                                <li v-if="locationList.length !== 0" class="p-2 color-blue " v-on:click.self="selectLocation($event, undefined, 3)">
                                                    Other
                                                </li>
                                            </ul>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="form-group" v-if="showLocOther">
                                      <label>New Pincode</label>
                                      <input type="text" class="form-control" name="locationPincode" id="locationPincode" v-model="editAddressFields.locationPincode" maxlength="6" v-on:blur="addressChanged(2)" v-on:keypress="isNumberEdit" v-validate="'required'"/>
                                      <span v-show="errors.has('editAddress.locationPincode')" class="text-danger">The Pincode field is required.</span>
                                  </div>
                                  <div class="form-group" v-if="showLocOther">
                                      <label>New Location</label>
                                      <input type="text" class="form-control" name="locationOther" id="locationOther" v-model="editAddressFields.locationOther" v-on:blur="addressChanged(2)" v-validate="'required'"/>
                                      <span v-show="errors.has('editAddress.locationOther')" class="text-danger">The Location field is required.</span>
                                  </div>
                                  <div class="form-group">
                                      <label>{{stateCityDisp}}</label>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div id="myMapVal"  style="width:100%;height:200px;background:#ccc"></div>
                            </div>
                          </div>
                          
                          <div class="row mmt-3">
                              <div class="col-sm-6">
                                    <a class="btn btn-link full-width" v-on:click="cancelModalPopup()">Cancel</a>
                                </div>
                                <div class="col-sm-6">
                                    <button class="btn btn-primary full-width" type="button" v-on:click="updateAddress()">Update</button>
                                </div>
                          </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bd-example-modal-lg" id="editMemberProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog  modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Profile Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form data-vv-scope="edit">
                            <div class="clearfix mt-4">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <input class="form-control" type="text" name="firstName" data-vv-as="first name" v-model="editMemberObj.firstName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                            <span v-show="errors.has('edit.firstName')" class="text-danger">{{ errors.first('edit.firstName') }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <input class="form-control" name="lastName" type="text" data-vv-as="last name" v-model="editMemberObj.lastName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                            <span v-show="errors.has('edit.lastName')" class="text-danger">{{ errors.first('edit.lastName') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Gender</label>
                                            <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'M')?true:false"> Male
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'F')?true:false"> Female
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="O" v-model="editMemberObj.sex" :checked="(editMemberObj.sex === 'O')?true:false"> Other
                                                </label>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group" >
                                                <label>Date of birth</label>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <select class="form-control" name="year" id="year"  v-model="year" v-on:change="getNumberOfDays()">
                                                            <option value="" class="dobOptionColor" disabled selected>YYYY</option>
                                                            <option v-for="(dobYear, index) in dobYears" v-bind:value="dobYear" :key='index'>{{dobYear}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4">
                                                        <select class="form-control" name="month" id="month" v-model="month" v-on:change="getNumberOfDays()">
                                                            <option value="" class="dobOptionColor" disabled selected>MMM</option>
                                                            <option value="01">Jan</option>
                                                            <option value="02">Feb</option>
                                                            <option value="03">Mar</option>
                                                            <option value="04">Apr</option>
                                                            <option value="05">May</option>
                                                            <option value="06">Jun</option>
                                                            <option value="07">Jul</option>
                                                            <option value="08">Aug</option>
                                                            <option value="09">Sep</option>
                                                            <option value="10">Oct</option>
                                                            <option value="11">Nov</option>
                                                            <option value="12">Dec</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4">
                                                    <select class="form-control" name="ddate" id="ddate" v-model="ddate">
                                                        <option value="" class="dobOptionColor" disabled selected>DD</option>
                                                        <option v-for="(dobDateVal, index) in dobDate" v-bind:value="dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''" :key='index'>{{dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : '' }}</option>
                                                    </select>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                                    </div>
                                                </div>
                                            </div>
                                          </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Mobile</label>
                                            <input class="form-control" type="text" name="phone1" data-vv-as="mobile no." v-model="editMemberObj.phone1" v-validate="'required|numeric|min:10|max:10'">
                                            <span v-show="errors.has('edit.phone1')" class="text-danger">{{ errors.first('edit.phone1') }}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">                                              
                                        <div class="form-group">
                                            <label>Alternate Phone No.</label>
                                            <input class="form-control" type="text" name="phone2" data-vv-as="alternate phone no." v-model="editMemberObj.phone2" v-validate="'numeric|min:10|max:10'">
                                            <span v-show="errors.has('edit.phone2')" class="text-danger">{{ errors.first('edit.phone2') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input style="background-color: #fff; cursor: not-allowed" class="form-control" type="email" name="email" data-vv-as="email address" v-model="editMemberObj.email" v-validate="'required|email|max:100'" :disabled="true">
                                            <i style="font-size: 18px; color: #000; text-align: right; float: right; margin-top: -25px; margin-right: 10px;" class="fa">&#xf023;</i>
                                            <span v-show="errors.has('edit.email')" class="text-danger">{{ errors.first('edit.email') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-6">
                                </div>
                                <div class="col-sm-3">
                                    <a class="btn btn-link full-width" v-on:click="cancelMember(1)">Cancel</a>
                                </div>
                                <div class="col-sm-3">
                                    <button class="btn btn-primary full-width" :disabled="(errors.any())" @click.prevent="saveProfile()">Update</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade bd-example-modal-sm" id="editPatientProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog  modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Edit Patient Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateMember" data-vv-scope="editMember">
                          <div class="clearfix mt-4 line-textbox">
                              <div class="form-group">
                                  <label>Patient First Name*</label>
                                  <input type="text" class="form-control" ref="editMemberFirstName" name="firstName" id="firstName" maxlength="50" data-vv-as="first name" v-model="editMemberFields.firstName" v-validate="'required|alpha_spaces|max:50'" />
                                  <span v-show="errors.has('editMember.firstName')" class="text-danger">{{ errors.first('editMember.firstName') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Patient Last Name*</label>
                                  <input type="text" class="form-control" name="lastName" id="lastName" maxlength="50" data-vv-as="last name" v-model="editMemberFields.lastName" v-validate="'required|alpha_spaces|max:50'" />
                                  <span v-show="errors.has('editMember.lastName')" class="text-danger">{{ errors.first('editMember.lastName') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Mobile*</label>
                                  <input type="text" class="form-control" name="mobile" v-mask="'##########'" id="mobile" maxlength="50" data-vv-as="last name" v-model="editMemberFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                  <span v-show="errors.has('editMember.mobile')" class="text-danger">{{ errors.first('editMember.mobile') }}</span>
                              </div>
                              <div class="form-group">
                                  <label>Gender*</label>
                                  <br>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="editMemberFields.sex"> Male
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="editMemberFields.sex"> Female
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="O" v-model="editMemberFields.sex"> Other
                                      </label>
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label>Age*</label>
                                  <input type="text" class="form-control" name="age" id="age" data-vv-as="age" v-model="editMemberFields.age" v-validate="'required|numeric|max:2'" />
                                  <span v-show="errors.has('editMember.age')" class="text-danger">{{ errors.first('editMember.age') }}</span>
                              </div>
                          </div>
                          <div class="row mt-3">
                              <div class="col-sm-6">
                                  <a class="btn btn-link full-width" v-on:click="cancelMember(2)">Cancel</a>
                              </div>
                              <div class="col-sm-6">
                                  <button class="btn btn-primary full-width" type="submit">Update</button>
                              </div>
                          </div>
                      </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade bd-example-modal-sm" id="addPatientProfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog  modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Add Patient Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                       <form @submit.prevent="saveMember" data-vv-scope="addMember">
                            <div class="clearfix mt-4 line-textbox">
                                <div class="form-group">
                                    <label>Patient First Name*</label>
                                    <input type="text" class="form-control" name="firstName" id="firstName" maxlength="50" data-vv-as="first name" v-model="addMemberFields.firstName" v-validate="'required|alpha_spaces|max:50'" />
                                    <span v-show="errors.has('addMember.firstName')" class="text-danger">{{ errors.first('addMember.firstName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Patient Last Name*</label>
                                    <input type="text" class="form-control" name="lastName" id="lastName" maxlength="50" data-vv-as="last name" v-model="addMemberFields.lastName" v-validate="'required|alpha_spaces|max:50'" />
                                    <span v-show="errors.has('addMember.lastName')" class="text-danger">{{ errors.first('addMember.lastName') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Mobile*</label>
                                    <input type="text" class="form-control" name="mobile" id="mobile" v-mask="'##########'" maxlength="50" data-vv-as="mobile" v-model="addMemberFields.mobile" v-validate="'required|numeric|min:10|max:10'" />
                                    <span v-show="errors.has('addMember.mobile')" class="text-danger">{{ errors.first('addMember.mobile') }}</span>
                                </div>
                                <div class="form-group">
                                    <label>Gender*</label>
                                    <br>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="addMemberFields.sex"> Male
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="addMemberFields.sex"> Female
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="O" v-model="addMemberFields.sex"> Other
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Age*</label>
                                    <input type="text" class="form-control" name="age" id="age" data-vv-as="age" v-model="addMemberFields.age" v-validate="'required|numeric|max:2'" />
                                    <span v-show="errors.has('addMember.age')" class="text-danger">{{ errors.first('addMember.age') }}</span>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-6">
                                    <a class="btn btn-link full-width" v-on:click="cancelMember(3)">Cancel</a>
                                </div>
                                <div class="col-sm-6">
                                    <button class="btn btn-primary full-width" type="submit">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade bd-example-modal-lg" id="termsAndCondition" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Terms and Condition</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-sm-12">
                            <p>Welcome to <b>www.labotist.com</b>. </p>
                            <p>The Terms & Conditions (“<b>Terms</b>”) of use of www.labotist.com (“<b>Website</b>”) are between Labotist Private Limited (“<b>Company/We/Us</b>”) and its customers/clients (“<b>You/Your/User(s)</b>”).</p>
                            <p>These Terms constitute an electronic record in accordance with the provisions of the Information Technology Act, 2000 and the Information Technology (Intermediaries Guidelines) Rules, 2011 thereunder, as amended from time to time.</p>
                            <p>Please read the Terms and the privacy policy of the Company carefully, available at <b><i>www.labotist.com/privacy-policy</i></b> (“<b>Privacy Policy</b>”) before using this Website or availing any Services (as defined below) through the Website. In the event of any discrepancy between the Terms and any other Website policies, the provisions of the Terms shall prevail.</p>
                            <p>If You continue to browse and use our Website, You are agreeing to comply with and be bound by the following Terms. If you disagree with any part of these Terms, please do not use our Website.</p>
                            <p>If You do not agree with the Terms or the Privacy Policy, please do not use the Website or avail the Services provided by this Website.</p>
                            
                            <h4>Introduction</h4>
                            <p>Our Website is an Internet based online platform operated by the Company which is a company incorporated under the Companies Act, 2013. Our Website is a convenient, technology driven platform that serves as a one-stop solution for patients to easily choose from, and connect with various laboratories  across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comfort of their home by a trained phlebotomist (“<b>Services</b>”).</p>

                            <p>Use of the Website is offered to You on the condition that You accept the same without modification of all the terms, conditions and notices contained in these Terms, as may be posted on the Website from time to time.</p>

                            <p>We reserve the right to amend these Terms from time to time as We deem fit and Your continued usage of the Website and the Services offered shall be deemed to be Your acceptance of the Terms. We recommend that, You keep yourself updated with the Terms. We do not hold the responsibility of informing You of any amendments.</p>

                            <p>Users may not access the Services for the purposes of monitoring their availability, performance or functionality, or for any other benchmarking or competitive purposes.</p>

                            <p>We reserve our right to suspend any User’s ability to use or access the Website at our sole discretion and at any time while We investigate complaints or alleged violations of these Terms, or for any other reason. We have the right to club profiles of the laboratories and diagnostic centres to make them more suitable for package searches on the Website while not amending any of the details provided by the concerned laboratories and diagnostic centres. If the Users find that there is any incorrect information, they can contact Us immediately for such corrections. However, We disclaim all liabilities or responsibilities with respect to any of the information provided by the concerned laboratories and diagnostic centres.</p>


                            <h4>Eligibility Criteria</h4>
                            <ul>
                                <li> The Services offered on the Website are not available to all those individuals who are not qualified to enter into a contract as per the Indian Contract Act, 1872.  By using the Website, You represent and warrant that (a) all registration information You submit is truthful and accurate; (b) You will maintain the accuracy of such information, and any changes thereto by regular updates of any such information; (c) You affirm that You are over 18 years of age and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these Terms; and (c) You shall use the Website or such other services provided under the Website only in compliance with these Terms and all applicable local, state, national, and international laws, rules and regulations. Your profile may be deleted and Your membership may be terminated by the Company without warning, or without any notice whatsoever, if We believe that You have violated any of the conditions as mentioned under the Terms or Privacy Policy.
                                </li>

                                <li>The Company reserves the right to grant or refuse usage of the Services available on the Website. It can also terminate the usage by an existent User of the Website without assigning any reason. </li>

                                <li>The Website does not have the responsibility to ensure that You conform to the aforesaid eligibility criteria. It shall be Your sole responsibility to ensure that You meet the required qualification.</li>
                            </ul>

                            <h4>User Account</h4>
                            <ul>
                                <li> You will be required to create an Account, if You wish to avail the Services offered on the Website.</li>

                                <li>In order to access the Services offered on the Website, You shall be required to register yourself with the Website, and maintain an account there ("<b>Account</b>"). You will be required to furnish certain information and details, including Your name, mobile number, e-mail address, residential address, payment information (credit/debit card details) if required, and any other information deemed necessary by the Website (“<b>Account Information</b>”).</li>

                                <li>It is Your sole responsibility to ensure that the Account Information provided by You is accurate, complete and latest.</li>

                                <li>The Account Information provided by You, may be shared by the Company with any third party for its internal record keeping purposes, internal procedures and with various laboratories/diagnostic centres to enable them to inform You about any schemes, offers, discounts etc.  Further, by providing the Account Information, you agree and acknowledge that you are also granting your consent for the phlebotomists to visit the address provided by you in order to collect/draw the requite samples, call you on the number provided you for any necessary confirmation, deliver the samples the diagnostic centre chosen by you and do such other acts as necessary. </li>

                                <li>Upon completing the registration process, You can start availing the Services offered on the Website immediately. You shall be responsible for maintaining the confidentiality of the Account Information and for all activities that occur under Your Account. You agree to (a) ensure that You successfully log out from Your Account at the end of each session; and (b) immediately notify the Company of any unauthorized use of Your Account.  If there is reason to believe that there is likely to be a breach of security or misuse of the Your Account/ Website, We may request You to change the password or We may suspend Your account without any liability to the Company, for such period of time as We deem appropriate in the circumstances. The Website shall not be liable for any loss or damage arising from Your failure to comply with this Clause.</li>

                                <li>You acknowledge that Your ability to use Your Account is dependent upon external factors such as internet service providers and internet network availability and the Company cannot guarantee availability of the Website at all times. In addition to the disclaimers set forth in the Terms, the Company shall not be liable to You for any damages arising from Your inability to log into Your Account and access the services of the Website at any time.</li>

                            </ul>

                            <h4>Use of Website</h4>
                            <ul>
                                <li>Subject to compliance with the Terms, the Privacy Policy, and all other applicable terms and guidelines, the Company grants You a personal, non-exclusive, limited privilege to access and use this Website and the Services provided thereon.</li>

                                <li>No User shall be permitted to perform any of the following prohibited activities:
                                    <ul>
                                        <li>Making available any content that is misleading, unlawful, harmful, threatening, abusive, tortious, defamatory, libelous, vulgar, obscene, child-pornographic, lewd, lascivious, profane, invasive of another's privacy, hateful, or racially, ethnically or otherwise objectionable.</li>

                                        <li>Stalking, intimidating and/or harassing another and/or inciting other to commit violence.</li>

                                        <li>Transmitting material that encourages anyone to commit a criminal offence, that results in civil liability or otherwise breaches any relevant laws, regulations or code of practice.</li>

                                        <li>Interfering with any other person's use or enjoyment of the Website.</li>

                                        <li>Making, transmitting or storing electronic copies of materials protected by copyright without the permission of the owner, committing any act that amounts to the infringement of intellectual property or making available any material that infringes any intellectual property rights or other proprietary rights of anyone else.</li>

                                        <li>Make available any content or material that You do not have a right to make available under any law or contractual or fiduciary relationship, unless You own or control the rights thereto or have received all necessary consents for such use of the content.</li>

                                        <li>Impersonate any person or entity, or falsely state or otherwise misrepresent Your affiliation with a person or entity.</li>

                                        <li>Use any of the Company’s domain names.</li>

                                        <li>Reverse engineer, modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information or software obtained from the Website.</li>

                                        <li>Post, transmit or make available any material that contains viruses, trojan horses, worms, spyware, time bombs, cancelbots, or other computer programming routines, code, files or such other programs that may harm the Website/services, interests or rights of other Users or limit the functionality of any computer software, hardware or telecommunications, or that may harvest or collect any data or personal information about other Users without their consent.</li>

                                        <li>Access or use the Website in any manner that could damage, disable, overburden or impair any of the Website's servers or the networks connected to any of the servers on which the Website is hosted.</li>

                                        <li>Intentionally or unintentionally interfere with or disrupt the Services or violate any applicable laws related to the access to or use of the Website, violate any requirements, procedures, policies or regulations of networks connected to the Website, or engage in any activity prohibited by these Terms.</li>

                                        <li>Disrupt or interfere with the security of, or otherwise cause harm to, the Website, materials, systems resources, or gain unauthorized access to user accounts, passwords, servers or networks connected to or accessible through the Website or any affiliated or linked sites.</li>

                                        <li>Interfere with, or inhibit any user from using and enjoying access to the Website, or the services, or other affiliated sites, or engage in disruptive attacks such as denial of service attack on the Website.</li>

                                        <li>Access the Website through any other means other than through the interface that is provided by the Company.</li>

                                        <li>Use deep-links, page-scrape, robot, spider or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to increase traffic to the Website, to access, acquire, copy or monitor any portion of the Website, or in any way reproduce or circumvent the navigational structure or presentation of the Website, or any content, to obtain or attempt to obtain any content, documents or information through any means not specifically made available through the Website.</li>

                                        <li>Alter or modify any part of the services.</li>

                                        <li>Use the services for purposes that are not permitted by: (i) these Terms; and (ii) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdiction.</li>

                                        <li>Violate any of the terms specified under the Terms for the use of the Website.</li>

                                    </ul>
                                </li>
                                <li>Any violation by You of the terms of this Clause may result in immediate suspension or termination of Your Accounts, apart from any legal remedy that the Company can avail. In such instances, the Company may also disclose Your Account Information if required by any Governmental or legal authority.</li>

                                <li>You acknowledge and agree that by accessing or using the Website, You agree to indemnify and hold the Company, its affiliates, and/or licensors, harmless to the fullest extent allowed by law regarding all matters related to Your use of the Website or any loss/damage that is caused to the Website/the Company as a result of You committing any of the aforesaid prohibited activities.</li>

                                <li>The Company has the right to change modify, suspend, or discontinue and/or eliminate any aspect(s), features or functionality of the Website or the Services as it deems fit at any time without notice. The Company makes no commitment, express or implied, to maintain or continue any aspect of the Website.  You agree that the Company shall not be liable to You or any third party for any modification, suspension or discontinuance of the Website.</li>

                                <li>You acknowledge that the Company does not make any representation or warranty  regarding any of its Users. You are advised to independently verify the bona fides of any particular user that You choose to deal with on the Website.</li>
                                
                            </ul>

                            <h4>Delivery of Reports </h4>
                            <ul>
                                <li> Sample collection will typically be done on the date and time chosen by the User. The User shall have the option to reschedule subject to the availability of the rescheduled time slot.</li>

                                <li>It is clarified that, certain sample collection procedure may get delayed due to certain unforeseen circumstances beyond the control of the Company. In such an event, We will proactively reach out to You and inform the same. You are expected to check your emails and SMS regularly for any such updates.</li>

                                <li>Reports will be generated within the turnaround time as stipulated by the laboratory/diagnostic centre chosen by the User. The Company is not liable for any delay with respect to the generation of the reports by such laboratory/diagnostic centre . Upon delivery of the reports to Us, We shall verify the User name and other necessary credentials after which the Company shall attach and e-mail a soft copy of the report to Your online account. The User shall be able to view the report only by logging into his/her Account.</li>

                                <li>Reported laboratory results are at best informative to the referring clinician and should not be considered as the sole basis for final diagnosis and treatment decisions. They should always be correlated with other relevant clinical and laboratory findings.</li>

                                <li>The accuracy of the laboratory reports is largely dependent on the quality of the sample as well as the assay procedures used by the laboratory/diagnostic centres chosen by the User.</li>
                                
                            </ul>

                            <h4>Payment, Fees and Taxes </h4>
                            <ul>
                                <li>The User agrees to pay all package fees, consulting fees and other fees applicable to the selected Services and the User shall not circumvent the fee structure. The fee is dependent on the package that the User purchases online and not on the actual usage of the Services.</li>

                                <li>Each User is solely responsible for the payment of all taxes. The Company shall be in no way responsible for any of the taxes except for its own tax liabilities.</li>

                                <li>The payment can be made online on the Website through a secured payment gateway provided by a third party. It is hereby clarified that, the Company is not responsible for any loss or damage caused to the User during the payment process as the third parties and their activities are beyond the control of the Company. The payment could also be paid offline and be either collected personally from the User.</li>

                                <li>All fees are exclusive of applicable taxes.</li>

                                <li>The Company reserves the right to modify the fee and such modified fee shall reflect on the Website, which shall be binding.</li>

                                <li>In order to process the payments, the User might be required to provide certain details of the his/her bank account, credit/debit card number and other details as required by the third party vendor to process the transactions. The Company clarifies that it does not own or store any credit/debit card information entered by the User.</li>

                                <li>You understand and acknowledge that the Company shall not be held responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:</li>
                                    <ul>
                                        <li>Lack of authorization for any transaction/s, or</li>
                                        <li>Exceeding the preset limit set by your bank, or</li>
                                        <li>Delay in processing the transaction; or</li>
                                        <li>Any payment issues arising out of the transaction; or</li>
                                        <li>Decline of transaction for any reason/s</li>
                                    </ul>

                                <li>All payments made against the purchases on the Website by You shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Website will not facilitate transactions with respect to any other form of currency with respect to availing of its services. </li>
                                
                            </ul>

                            <h4>Cancellation and Refund Policy</h4>
                            <ul>
                                <li>The User can cancel the test request by calling on the phone number mentioned in the order confirmation notification.</li>

                                <li>All laboratory test requests can be canceled until 12 (twelve) hours prior of the scheduled sample collection appointment to be eligible for a full refund.</li>

                                <li>For any requests cancelled less than 12 (twelve) hours prior to the scheduled sample collection appointment  or after the appointment, the User would incur an administrative charge of INR 100 (Rupees One Hundred). This is primarily to compensate the phlebotomist for a lost opportunity to provide the home sample collection service and earn his/her income.</li>

                                <li>Any requests not cancelled before the scheduled sample collection will NOT receive any refund. All refunds will be processed and credited within 15 (fifteen) business days from the date of the cancellation request into the account of the User.</li>

                            </ul>

                            <h4>Limitation of Liability</h4>
                            <ul>
                                <li>The Company, its officers, directors, employees, partners or agents shall not be held responsible or held liable to You or any third party for any special, incidental, indirect, consequential or punitive damages whatsoever, including those resulting from loss of use, data or profits or any other claim arising out, of or in connection with, Your use of, or access to, the Website.</li>

                                <li>The Company shall not be held responsible or liable in any manner whatsoever, by the Users for any losses, damage, injuries or expenses incurred by the Users as a result of any lawful disclosures made by the Company, where the User has consented to such disclosures by the Company. The User agrees that the services provided by the Company or any of its affiliates or service providers are provided on an  "as is," basis, and without any warranties or conditions (<i>express or implied, including the implied warranties of merchantability, accuracy, fitness for a particular purpose, title and non-infringement, arising by statute or otherwise in law or from a course of dealing or usage or trade</i>). The Company does not provide or make any representation, warranty or guarantee, express or implied about the Website or the Services. The Company does not verify any content or information provided by the Users/User selected laboratories/diagnostic centres on the Website and to the fullest extent permitted by law, disclaims all liability arising out of the User’s use or reliance upon the Website, the Services, representations and warranties made by the laboratories/diagnostic centres or the content or information provided by laboratories/ diagnostic centres on the Website or any loss arising out of the manner in which the Services have been rendered.</li>

                                <li>In no event shall the total aggregate liability of the Protected Entities to a User for all damages, losses, and causes of action (<i>whether in contract or tort, including, but not limited to, negligence or otherwise</i>) arising from the terms and conditions or a User’s use of the Website exceed, in the aggregate INR 1,000 (Rupees One Thousand). </li>
                                
                                <li>Notwithstanding anything to the contrary contained herein, the User alone shall be liable for User’s dealings and interaction with the chosen laboratory/diagnostic centres. </li>
                                
                                <li>In no event shall the Company be held responsible and liable for failure on the part of the chosen laboratories/ diagnostic centres to provide the agreed Services or to make provisions for the carrying out the Services. In no event shall the Company be liable for any comments or feedback given by any of the Users in relation to the Services provided by any chosen laboratories/diagnostic centres.</li>
                                
                                <li>The listing of the laboratories/diagnostic centres on the Website is based on numerous factors including but not limited to the User’s comments and feedbacks. In no event shall the Company be liable or responsible for the listing order of the laboratories/diagnostic centres on the Website.</li>
                                
                                <li>We shall not be held responsible or liable for, any damages to, or viruses that may infect User’s equipment on account of User’s access to, use of, or browsing the Website or the downloading of any material, data, text, images, video content, or audio content from the Website. If a User is dissatisfied with the Website, User’s sole remedy is to discontinue using the Website.</li>
                                
                            </ul>

                            <h4>Ownership and Intellectual Property Rights</h4>
                            <ul>
                                <li>The Website and the materials therein including but not limited to all text, graphics, user interfaces, visual interfaces, sounds and music (<i>if any</i>), artwork and computer code and any other information or materials of any nature whatsoever on the Website is owned and controlled by the Company and such content is protected by copyright, patent and trademark laws, and various other intellectual property rights and unfair competition laws.</li>
                                
                                <li>The trademarks, logos and service marks displayed on the Website or on the Website (the "<b>Marks</b>") are the property of Company or the respective third parties. You are not permitted to use the Marks without the prior consent of the Company or the third party that may own the Marks.</li>
                                
                            </ul>

                            <h4>Termination of Your Account</h4>
                            <ul>
                                <li>The Company may at its sole discretion and without prior notice, terminate Your access to the Website and its Services for, including but not limited to, any of the following reasons:</li>
                                <ul>
                                    <li>Your violation of the Terms as mentioned herein.</li>
                                    
                                    <li>If the Company is unable to verify or authenticate any information provided to by You.</li>

                                    <li>If the Company at its sole discretion believes that Your actions may cause any damage or legal liability for other Users or to  the Company or are contrary to the interests of the Company.</li>
                                    
                                </ul>
                                <li>On termination of an Account due to the reasons mentioned herein, such User shall no longer have access to and the reports and other material stored on the Website by such User. The User shall ensure that he/she has continuous backup of the reports.</li>

                                <li>The Company reserves the right, at its sole discretion, to pursue all of its legal remedies, including but not limited to deletion of the User’s content from the Website with or without ability to access the Website and the other services, upon any breach by the User under this Terms or if the Company is unable to verify or authenticate any information provided by the User or if the User fails to provide (or after providing such consent, later revokes) the consents necessary or desirable by the Company to provide the services to the User.</li>

                            </ul>

                            <h4>Indemnification</h4>
                            <ul>
                                <li>You agree to defend, indemnify and hold harmless the Company, its officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) Your use of and access of the Website; (ii) Your violation of any term of these Terms or any other policy of the Company; (iii) Your violation of any third party right, including without limitation, any copyright, property, or privacy right; or (iv) any claim that Your use of the Website has caused damage to a third party. The defense and indemnification obligation will survive these Terms.</li>
                            </ul>

                            <h4>Governing Law and Jurisdiction</h4>
                            <ul>
                                <li>The Website, the Terms, all transactions entered into on or through the Website and the relationship between You and the Company shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. The courts of Chennai shall have the jurisdiction to try any dispute between the User and Company.</li>
                            </ul>

                            <h4>General Provisions</h4>
                            <ul>
                                <li><b>Notice:</b> All notices served by the Company shall be provided via email to Your account or as a general notification on the Website. Any notice to be provided to the Company should be sent to <b>[•]</b>.</li>
                                
                                <li><b>Entire Agreement:</b> The Terms, along with the Privacy Policy, and any other guidelines made applicable by the Website from time to time, constitute the entire agreement between the Company and You with respect to Your access to or use of the Website and the Services thereof.</li>
                                
                                <li><b>Assignment:</b> You cannot assign or otherwise transfer the Terms, or any right granted hereunder to any third party. The Company’s rights under the Terms are freely transferable by the Company to any third parties without the requirement of seeking Your consent. The Company may freely transfer, assign or delegate all or any part of these Terms, any rights and duties hereunder. These Terms will be binding upon and inure to the benefit of the successors and permitted assignees of the parties.</li>
                                
                                <li><b>Severability:</b> If, for any reason, a court of competent jurisdiction finds any provision of the Terms, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to give effect to the intent of the parties as reflected by that provision, and the remainder of the Terms shall continue in full force and effect.</li>
                                
                                <li><b>Waiver:</b> Any failure by the Company to enforce or exercise any provision of the Terms, or any related right, shall not constitute a waiver by the Company of that provision or right.</li>
                                
                                <li><b>Force Majeure:</b> The Company shall not be held responsible or liable due to any unavailability caused by circumstances beyond the Company’s reasonable control, including without limitation, Acts of God, acts of Government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labour problems such as strikes and lockouts, or internet service provider failures or delays.</li>
                                
                                <li><b>Relationship:</b> You acknowledge that Your participation on the Website, does not make You an employee or agency or partnership or joint venture or franchise of the Company. Further, you shall not have the right to enter into any obligation or commitment on behalf of the Company.</li>
                                
                                <li>The Company provides these Terms on the Website so that You are aware of the terms that apply to Your use of the Website. You acknowledge that, the Company has given You a reasonable opportunity to review these Terms and that You have agreed to them.</li>
                                
                                <li>In the event that you participate in any promotional activities through the advertisers on the Website, the Company shall not be held responsible for any loss or damage caused to you in this regard.</li>
                            </ul>

                            <h4>DISCLAIMER</h4>

                            <p class="terms-disclaimer"><b>WE DO NOT PROVIDE MEDICAL ADVICE:</b> THE INFORMATION THAT YOU OBTAIN OR RECEIVE FROM THE COMPANY, AND ITS EMPLOYEES, CONTRACTORS, PARTNERS, SPONSORS, ADVERTISERS, LICENSORS OR OTHERWISE ON THE WEBSITE IS FOR INFORMATIONAL AND SCHEDULING PURPOSES ONLY. THE INFORMATION PROVIDED ON THE WEBSITE IS NOT INTENDED AS A SUBSTITUTE FOR, NOR DOES IT REPLACE, PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR TREATMENT. DO NOT DISREGARD, AVOID OR DELAY OBTAINING MEDICAL ADVICE FROM A QUALIFIED HEALTH CARE PROFESSIONAL BECAUSE OF SOMETHING YOU MAY HAVE READ ON THE WEBSITE. DO NOT USE THE WEBSITE FOR EMERGENCY MEDICAL NEEDS. YOUR USE OF INFORMATION PROVIDED ON THE WEBSITE IS SOLELY AT YOUR OWN RISK. NOTHING STATED OR POSTED ON THE WEBSITE OR AVAILABLE THROUGH ANY SERVICES IS INTENDED TO BE, AND MUST NOT BE TAKEN TO BE, THE PRACTICE OF MEDICINE OR THE PROVISION OF MEDICAL CARE. WE DO NOT RECOMMEND OR ENDORSE ANY SPECIFIC TESTS, PHYSICIANS, LABORATORIES, DIAGNOSTIC CENTRES, PROCEDURES, OPINIONS, OR OTHER INFORMATION THAT MAY APPEAR ON THE WEBSITE. IF YOU RELY ON ANY OF THE INFORMATION PROVIDED BY THE WEBSITE, YOU DO SO SOLELY AT YOUR OWN RISK.</p>

                            <p class="terms-disclaimer"><b>NO DOCTOR PATIENT RELATIONSHIP:</b> NO LICENSED MEDICAL PROFESSIONAL/PATIENT RELATIONSHIP IS CREATED BY USING THE INFORMATION PROVIDED BY OR THROUGH THE USE OF THE WEBSITE INCLUDING, BUT NOT LIMITED TO, FIND A TEST FEATURE, LINKS TO OTHER WEBSITES OR ANY ASSISTANCE WE MAY PROVIDE TO HELP YOU FIND AN APPROPRIATE MEDICAL PROFESSIONAL/DIAGNOSTIC CENTER OR SPECIALIST IN ANY FIELD FOR CONDUCTING THE REQUISITE TEST. WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN REGARDING THE LABORATORIES/DIAGNOSTIC CENTRE OR THER PHLEBOTOMISTS. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON SUCH INFORMATION. WE HAVE NOT CONDUCTED ANY BACKGROUND CHECK ON THE PHLEBOTOMISTS AND WE ARE IN NO WAY LIABLE FOR ANY OF THEIR ACT/OMISSIONS. WE HAVE NO CONTROL OVER, AND CANNOT GUARANTEE THE AVAILABILITY OF ANY DIAGNOSTIC CENTER AT ANY PARTICULAR TIME. WE WILL NOT BE LIABLE FOR CANCELLED OR OTHERWISE UNFULFILLED APPOINTMENTS OR ANY INJURY RESULTING THEREFROM, OR FOR ANY OTHER INJURY RESULTING FROM THE USE OF THE WEBSITE OR SERVICES WHATSOEVER. YOU ARE STRONGLY ADVISED TO PERFORM YOUR OWN INVESTIGATION PRIOR TO SELECTING A HEALTH CARE DIAGNOSTIC CENTRE BY MAKING CONFIRMING TELEPHONE CALLS TO THE RELEVANT DIAGNOSTIC CENTRE. ANY KIND OF AN ENGAGEMENT WITH THE THIRD PARTIES INCLUDING WITH THE DIAGNOSTIC CENTRE WOULD BE ON A PRINCIPAL TO PRINCIPAL BASIS ON THE BEST JUDGEMENT OF YOURSELF.</p>


                            <h4>Feedback</h4>
                            <ul>
                                <li>Any feedback You provide to this Website shall be deemed to be non-confidential. The Website shall be free to use such information on an unrestricted basis. Further, by submitting the feedback, You represent and warrant that (i) Your feedback does not contain confidential or proprietary information of You or of third parties; (ii) the Company is not under any obligation of confidentiality, express or implied, with respect to the feedback; (iii) the Website may have something similar to the feedback already under consideration or in development; and (iv) You are not entitled to any compensation or reimbursement of any kind from the Company for the feedback under any circumstances, unless specified.</li>

                                <li>Under no circumstances shall the Company be held responsible in any manner for any content provided by other users even such content is offensive, hurtful or offensive. Please exercise caution while accessing the Website.</li>
                                
                            </ul>

                            <h4>Customer Care</h4>
                            <ul>
                                <li>We make all best endeavors to provide you with a pleasant experience. In the unlikely event that You face any issues, please contact us at <b>[•]</b></li>
                            </ul>
                        </div>
                      </div>
                      <div class="row mt-3">
                          <div class="col-sm-6">
                              <a class="btn btn-link full-width" v-on:click="termsConditionChanged(0)">Close</a>
                          </div>
                          <div class="col-sm-6">
                              <button class="btn btn-primary full-width" v-on:click="termsConditionChanged(0, true)">I Agree</button>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bd-example-modal-lg" id="privacyPolicy" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Privacy Policy</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-sm-12">
                            <p>About Labotist Private Limited </p>

                            <p>Labotist Private Limited (“<b>We</b>” and/or “<b>Us</b>” and/or “<b>Company</b>”) is a company incorporated under the Companies Act, 2013. Our website is a convenient, technology driven platform that serves as a one stop solution for patients to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, offering patients the convenience of making their choice based on location, cost of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples collected in the comforts of their home by a trained phlebotomist.</p>

                            <p>Similarly, our Website also serves as a marketplace for phlebotomists who are registered on our website. Our Company screens the phlebotomist as commercially viable and creates a well-intended marketplace for phlebotomist to serve as micro entrepreneurs.</p>

                            <p>The Company is concerned about the privacy of its users ("<b>User(s)</b>" and/or "<b>You</b>" and/or “<b>Your</b>”) accessing its Website. online platform in the name and style of www.labotist.com (the "<b>Website</b>").</p>

                            <p>Please read the Privacy Policy (“<b>Policy</b>”) carefully before using the Website, along with the Terms of Use (“<b>Terms</b>”) provided on the Website. Your use of the Website or the services provided by the Website shall signify Your acceptance of this Policy and Your agreement to be legally bound by the same.</p>

                            <p>If You do not agree with the terms of this Policy, do not use the Website or avail any of the services offered on this Website.</p>


                            <h4>About the policy</h4>
                            <p>When You register with the Website, We may seek and collect certain personal information for Your use of the Website. You consent to the collection, use, and disclosure of the information in accordance with this Policy. Therefore, We request You to read this Policy carefully before using the Website. </p>

                            <p>Please note that, We respect and value Your privacy and shall strive towards protecting the information that You provide. We shall keep the information provided to Us as confidential to the extent reasonably possible. You understand that, by registering on the Website, your personal information may be collected. If at any time You wish to have Your information deleted, You can write to <i>support@labotist.com</i>. We shall do the needful within 5 working days but We may retain certain information for internal purposes if required under applicable law.</p>

                            <p>Your privacy is of utmost importance to us. We shall process and save your information in accordance with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices And Procedures And Sensitive Personal Data Or Information) Rules, 2011.</p>

                            <h4>collection of personally identifiable information</h4>
                            <p>We collect personally identifiable information (name, phone number, email etc.) from you when you request for a service. We do not for any reason whatsoever sell your Personal Identifiable Information to any third party or otherwise trade on it.</p>

                            <p>The personal information You may provide to Us that We may use is as follows:</p>
                            <ul>
                                <li>Registration details: This will include the password provided by You for which We use reasonable security measures for password protection from anyone.</li>
                                <li>Your usage behavior on the Website.</li>
                                <li>The details of the computer system or computer network that You use to visit the Website and any activities undertaken through the usage of the Website.</li>
                                <li>Your first and last name, e-mail address, phone number, billing and shipping address.</li>
                            </ul>

                            <p>The fundamental reason behind collecting Your personal information is to support and facilitate You to enjoy various features and services provided on the Website. </p>
                            <p>We select and track Your preferences to provide You with a customized Website experience, to notify You of any updated information and new developments/features and other related functions offered by the Website, to otherwise support Your relationship with Us and to prevent fraud and unlawful use.</p>

                            <p>By accepting the terms of this Policy, You understand, agree and recognize that our storage and processing of Your personal information is for a lawful purpose associated with a function or an activity of the Website. You further understand, agree and acknowledge that You may be required to provide personal information that is classified as sensitive personal information as per applicable laws for Us to provide various services. </p>

                            <p>Please note that, it is entirely up to the discretion of the User to provide this personal information. However, the User would not be able to avail the services provided by Us if this information is denied.</p>

                            <p>We do not sell, trade or rent Your personal information to any third party unless We have been expressly authorized by You either in writing or electronically to do so. We may at times provide aggregate statistics about our customers, traffic patterns, and related site information to reputable third parties, however this information when disclosed will be in an aggregate form and does not contain any of Your personally identifiable information.</p>

                            <p>You may note that, We adopt reasonable security measures to protect Your password from being exposed or disclosed to anyone</p>

                            <h4>information sharing and disclosure:</h4>
                            <p>We are the recipient of all the personal information and shall exercise reasonable care to keep Your personal information confidential to the maximum possible extent. We may limit disclosure of the Users' information to our entities, joint ventures, agents, sellers or third parties for the purposes of the services provided by them or for any other marketing related activity undertaken by or on behalf of our entities and/or its joint ventures on a need-to-know basis. We shall not be liable for any unauthorized use or disclosure of the personal information by any sellers participating on our Websites.</p>

                            <p>We may use the information We collect from You when You register, place an order, sign up for our newsletter, respond to a survey or marketing communication, surf the Website, or use certain other site features in the following ways: To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested. </p>

                            <h4>legal compliance</h4>
                            <p>We abide by all the applicable laws in force as well as the mandates of government agencies. We will disclose any information about You to government or law enforcement officials or private parties that We, in our sole discretion, believe necessary or appropriate to respond to claims and legal processes, to protect the property and rights of the Company or a third party, to protect the safety of the public or any person, or to prevent or stop any illegal, unethical or legally fraudulent activity. We may also provide Your personal information to various regulatory authorities upon any demand or request from them.</p>
                            
                            <p>We may provide your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy of the Company.</p>

                            <p>We do not use vulnerability scanning and/or scanning for payment transaction. All our scanning with respect to payments is in compliant with Payment Card Industry Data Security Standard (“<b>PCI</b>”) standards. An external PCI compliant payment gateway handles all our credit card transactions. We use regular malware scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (“SSL”) technology. We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information. All transactions are processed through a gateway provider and are not stored or processed on our servers. </p>



                            <h4>email policies</h4>
                            <p>You can choose the type of emails that You wish to receive from Us. If You decide at any time that You no longer wish to receive such communications from Us, please follow the unsubscribe instructions provided in any of the communications. Please note that, once We receive Your request, it may take an additional period of time for Your subscription to become ineffective.</p>

                            <h4>deletion of your information:</h4>
                            <p>If You wish to have the personal information that You have provided to us deleted, You can do so by writing to <i>support@labotist.com</i>. Please note that deletion of certain personal information may lead to deletion of Your account with the Website and Your access to certain features of the Website.  You understand that under certain circumstances, the request for the deletion of personal information can be denied.</p>

                            
                            <h4>security:</h4>
                            <p>We strive to work towards the security, integrity and privacy of Your personal information and to protect Your personal information against unauthorized disclosure, access or destruction to the extent reasonably possible by Us. Notwithstanding anything contained in this Policy or elsewhere, We shall not be held responsible for any loss, damage or misuse of Your personal information, if such loss, damage or misuse takes place as a result of a Force Majeure Event (as defined below).</p>


                            <p>A "<b>Force Majeure Event</b>" shall mean any event that is beyond our reasonable control and shall include, without limitation, fire, flood, explosion, acts of God, civil commotion, strikes, insurrection, war, acts of government, computer hacking, software failure and storage device, computer crashes etc</p>

                            <h4>third-party disclosure</h4>
                            <p>We may disclose Your personal information solely in the legitimate conduct of the business to deliver services to meet Your demands. We may also release information when We believe, in good faith, that such release is reasonably necessary to (1) comply with legal or regulatory requirements; (2) enforce or apply terms of use of our Website; or (3) protect our rights, property or safety of the rights of others.</p>

                            <p>Although We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice, this does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.</p>

                            <p>However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.</p>

                            <h4>links to other sites</h4>
                            <p>The Website may provide third-party advertisements and links to other websites. We do not provide Your personal information to these third-party websites or advertisers.</p>

                            <p>The links to other websites are operated by third parties and are not controlled by, or affiliated to, or associated with Us unless expressly specified on the Website. Therefore, We do not make any claims concerning the privacy practices or policies of such third parties or terms of use of such websites, nor do We control or guarantee or endorse the accuracy, integrity, or quality of the information available on such websites. Any information provided by You to such third party websites shall be governed in accordance with the privacy policies of the respective websites and it is strongly recommended that You review the privacy policy on any such websites prior to using such websites.</p>

                            <h4>google</h4>
                            <p>Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. Click here to view We use Google AdSense Advertising on our Website.</p>

                            <p>Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.</p>

                            <p>We have implemented the following:</p>
                            <ul>
                                <li>Google Display Network Impression Reporting</li>
                                <li>Demographics and Interests Reporting</li>
                            </ul>
                            <p>We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.</p>

                            <h4>how does our website handle do not track signals?</h4>
                            <p>We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place.</p>

                            <h4>research</h4>
                            <p>In support of eHealth initiatives, we may use and share your medical information for research. We will only use and share information for research after obtaining your consent or if the used data does not expressly identify you in any way.</p>

                            <h4>studies and reports</h4>
                            <p>We may use your information to study results and produce reports. Such information may be shared with Our partners and advertisers under the sole discretion of the Company.</p>

                            <h4>changes to this privacy policy</h4>
                            <p>Any changes we may make to our Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Please check back frequently to see any updates or changes to our Policy.</p>

                            <h4>phishing</h4>
                            <p>Identity theft and the fraudulent practice currently known as "phishing" are of great concern to Us. Phishing is an attempt to acquire personal/sensitive information which the legitimate organization already has. Safeguarding information to help protect You from identity theft is a top priority. We do not and will not, at any time, request Your credit card information or national identification numbers in a non-secure or unsolicited e-mail or telephone communication.</p>

                            <h4>cookies</h4>
                            <p>Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, We use cookies to help us remember the services/packages obtained by you. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.</p>

                            <p>We use cookies to:</p>
                            <ul>
                                <li>Understand and save user's preferences for future visits.</li>
                                <li>Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.</li>
                            </ul>

                            <p>You can choose to have Your computer warn you each time a cookie is being sent, or You can choose to turn off all cookies. You can do this through Your browser settings by utilizing the <i>Help Menu</i> to learn the correct way to modify your cookies. If You turn cookies off, some of the features that make Your site experience more efficient may not function properly. It won't affect the User's experience that make Your site experience more efficient and may not function properly. </p>

                            <h4>contact</h4>
                            <p>Our Grievance Officer shall undertake all reasonable efforts to address your grievances at the earliest possible opportunity. You may contact us at:</p>

                            <p>Grievance Officer: Jayaprakaash Jayaraman</p>
                            <p><b>Address:</b><br/>
                            Flat No 8, 2nd Floor, <br/>
                            Old No 4, New No 5 Rajachar Street, <br/>
                            T.Nagar, Chennai - 600017</p>
                            <p>Reach out to us on <i>support@labotist.com</i>, in case of any queries.</p>
                        </div>
                      </div>
                      <div class="row mt-3">
                          <div class="col-sm-6">
                              <a class="btn btn-link full-width" v-on:click="termsConditionChanged(0)">Close</a>
                          </div>
                          <div class="col-sm-6">
                              <button class="btn btn-primary full-width" v-on:click="termsConditionChanged(0, true)">I Agree</button>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
import _ from 'underscore'
import dateFormat from 'dateformat'
import Datepicker from 'vuejs-datepicker'
import('./checkout')
export default {
  name: 'SelectAddress',
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
    if (!this.$localStorage.get('location') || !this.$localStorage.get('st')) {
      this.$router.push({ path: '/lab' })
    } else if (!this.$localStorage.get('sl')) {
      this.$router.push({ path: '/lab' })
    } else if (!this.$localStorage.get('ct')) {
      this.$router.push({ path: '/appointment' })
    } else if (!this.$localStorage.get('sa')) {
      this.$router.push({ path: '/address' })
    } else if (!this.$localStorage.get('sm')) {
      this.$router.push({ path: '/address' })
    }
  },
  components: {
    HeaderVue,
    FooterVue,
    Datepicker
  },
  data () {
    return {
      selectedLab: [],
      selectedProfileAndTest: [],
      activeAddress: [],
      activeMembers: [],
      testCosts: {},
      payinfo: {
        creditPoints: 0
      },
      addresses: {},
      members: {},
      isAddressActiveId: 0,
      isMemberActiveId: 0,
      isMe: true,
      addMemberForm: false,
      editMemberForm: false,
      addMemberFields: {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: ''
      },
      editMemberFields: {},
      addAddressForm: false,
      editAddressForm: false,
      locationList: [],
      addAddressFields: {},
      editAddressFields: {},
      stateCityDisp: '',
      showLocOther: false,
      couponCode: '',
      couponData: undefined,
      couponError: '',
      isSuccessCoupon: false,
      profileDetails: {},
      map: undefined,
      marker: undefined,
      mapCoordinates: undefined,
      editMemberObj: {
        firstName: '',
        lastName: '',
        email: '',
        phone1: '',
        phone2: '',
        dob: undefined,
        sex: '',
        photo: '',
        address: {},
        disabled: {
          from: new Date()
        }
      },
      isDobError: false,
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      addressZipCode: '',
      isInvalidPincode: false,
      onBlurKey: 'none',
      isCouponApplied: false,
      selectedLocality: undefined,
      termsCondition : false,
      termsConditionError : false,
      paymentType : '1',
      redeemCredits : false,
      redeemCreditPoints : '',
      toolCostExeeds : false
    }
  },
  watch: {
    redeemCredits: function () {
      if(this.redeemCredits) {
        this.redeemCreditPoints = this.payinfo.creditPoints
        this.creditPointChanged()
      } else {
        this.redeemCreditPoints = 0
        this.creditPointChanged()
      }
      
    }
  },
  methods: {
    creditPointChanged: function () {
      if (this.payinfo.creditPoints && this.payinfo.creditPoints > 0) {
        if (this.payinfo.creditPoints < this.redeemCreditPoints) {
          this.redeemCreditPoints = this.payinfo.creditPoints
        } else {
          if(this.redeemCreditPoints > this.payinfo.grandTotal) {
            this.toolCostExeeds = true
            setTimeout(function(){
              this.toolCostExeeds = false
            }.bind(this), 2000)
            this.redeemCreditPoints = this.payinfo.grandTotal
          }
        }
      }
    },
    termsConditionChanged: function (type, data) {
      this.termsConditionError = false
      if (type == 1) {
        if(this.termsCondition) {
          $('#termsAndCondition').modal('show')
        }
      } else if (type == 0) {
        if(data) {
          this.termsCondition = true
        }
        $('#termsAndCondition').modal('hide')
        $('#privacyPolicy').modal('hide')
      } else if (type == 2) {
        $('#termsAndCondition').modal('show')
      } else if (type == 3) {
        $('#privacyPolicy').modal('show')
      }
    },
    getNumberOfDays: function (dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        let noOfDays = new Date(this.year, this.month, 0).getDate()
        this.dobDate = []
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString())
        }
        if (dateVal) {
          this.ddate = dateVal
        } else {
          if (this.ddate) {
            var res = true
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false
              }
            }.bind(this))
            if (res) {
              this.ddate = ''
            }
          }
        }
      }
      return false
    },
    goPayment: function (zeroPayment) {
      this.termsConditionError = false
      if (!this.$localStorage.get('st')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select a test or profile`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        return false
      } else if (!this.$localStorage.get('sl')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select a lab`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        return false
      } else if (!this.$localStorage.get('ct')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select your apoointment date and time`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        return false
      } else if (!this.$localStorage.get('sa')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select or add your address`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        return false
      } else if (!this.$localStorage.get('sm')) {
        this.$Simplert.open({
          title: 'Alert',
          message: `Please select your member`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
        return false
      } else {
        Vue.analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'PAYMENT INITIATED',
          contents: '',
          content_type: 'PAYMENT_INITIATED'
        })
        if(!this.termsCondition) {
          this.termsConditionError = true
          return false;
        }
        if(this.paymentType == '2' || zeroPayment) {
          if(!zeroPayment) {
            this.$Simplert.open({
              title: 'Information',
              message: `
                  <div style="text-align: left; line-height: 20px;">
                    <p>Please make arrangements to pay <b>Rs.${this.payinfo.grandTotal-this.redeemCreditPoints}</b> as cash to the Phlebotomist when he/she visits to collect sample. </p>
                    <p>If there are any changes to your schedule, please call ahead to reschedule. Uninformed cancelation will result in loss of time & money for our Phlebotomists.</p>
                    <p>Thanks for understanding. </p>
                  </div>`,
              type: 'info',
              useConfirmBtn: true,
              onConfirm: function(){this.saveRequestCash()}.bind(this),
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            })
          } else {
            this.saveRequestCash(zeroPayment)
          }
          
        } else {
          this.saveRequestFirst()
        }
        return false
      }
    },
    calculateAge: function (birthday) { // birthday is a date
      var ageDifMs = Date.now() - birthday.getTime()
      var ageDate = new Date(ageDifMs) // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    },
    getProfileOld: function () {
      try {
        this.profileDetails = {}
        Promise.resolve(this.$GET('patient/getProfile', {})).then(function (res) {
          if (res.response_code === 0) {
            this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName
            this.profileDetails['firstName'] = res.response.Patient.firstName
            this.profileDetails['lastName'] = res.response.Patient.lastName
            this.profileDetails['photo'] = res.response.Patient.photo
            this.profileDetails['dob'] = dateFormat(res.response.Patient.dob, 'dd-mm-yyyy')
            this.profileDetails['phone1'] = res.response.Patient.phone1
            this.profileDetails['phone2'] = res.response.Patient.phone2
            this.profileDetails['sex'] = res.response.Patient.sex
            this.profileDetails['email'] = res.response.email
            if (res.response.Patient.dob) {
              this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob))
            } else {
              this.profileDetails['age'] = 0
            }
          }
        }.bind(this)).catch(function (err) {
          console.log(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    searchLocation: function (pincode) {
      try {
        if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {
            'zipcode': pincode
          }
          Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    searchLocality: function (type) {
      this.isInvalidPincode = false
      if (type === 1) {
        if (!this.editAddressFields.locality || this.editAddressFields.zipcode !== (this.editAddressFields.locality.locationName + '-' + this.editAddressFields.locality.locationZipCode)) {
          this.onBlurKey = 'block'
          this.editAddressFields.locality = undefined
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'keyword': this.editAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              }
              Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.locationList = res.response
                } else {
                  this.locationList = []
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      } else if (type === 2) {
        if (!this.addAddressFields.locality || this.addAddressFields.zipcode !== (this.addAddressFields.locality.locationName + '-' + this.addAddressFields.locality.locationZipCode)) {
          this.onBlurKey = 'block'
          this.addAddressFields.locality = undefined
          try {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'keyword': this.addAddressFields.zipcode,
                'city': this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
              }
              Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.locationList = res.response
                } else {
                  this.locationList = []
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      }
    },
    closeBlock: function () {
      setTimeout(function () {
        this.onBlurKey = 'none'
      }.bind(this), 300)
    },
    selectLocation: function (event, obj, type) {
      this.isInvalidPincode = false
      if (type === 1) {
        this.showLocOther = false
        this.editAddressFields.locality = obj
        this.editAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode
        this.locationList = []
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName
        this.mapWithAddressEdit(this.editAddressFields, 2)
      } else if (type === 2) {
        this.showLocOther = false
        this.addAddressFields.locality = obj
        this.addAddressFields.zipcode = obj.locationName + '-' + obj.locationZipCode
        this.locationList = []
        this.stateCityDisp = obj.City.cityName + ', ' + obj.State.stateName
        this.mapWithAddressAdd(this.addAddressFields, 2)
      } else if (type === 3) {
        this.addAddressFields.locality = 'OTHER'
        this.addAddressFields.zipcode = 'OTHER'
        this.editAddressFields.locality = 'OTHER'
        this.editAddressFields.zipcode = 'OTHER'
        this.showLocOther = true
        this.stateCityDisp = this.selectedLocality.City.cityName + ',' + this.selectedLocality.State.stateName
      }
    },
    getTestCosts: function (lab) {
      try {
        let labTestCosts = []
        if (this.$localStorage.get('sl')) {
          if ((this.$localStorage.get('sl').labTestList).length > 0) {
            _.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        let data = {
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts
        }
        Promise.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response
              // let payinfo = {}
              // payinfo['mrpTotal'] = res.response.mrp
              // payinfo['phlebotomistFee'] = this.$phlebotomistFee
              // payinfo['subTotal'] = (payinfo.mrpTotal + payinfo.phlebotomistFee)
              // payinfo['labDiscount'] = res.response.youSaved
              // payinfo['phlebotomyFeeWaiver'] = ((payinfo.mrpTotal - payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              // payinfo['total'] = payinfo.subTotal - (payinfo.labDiscount + payinfo.phlebotomyFeeWaiver)
              // payinfo['gst'] = Math.round(((payinfo.total) * this.$GSTFee) / 100)
              // payinfo['grandTotal'] = (payinfo.total + payinfo.gst)
              // this.payinfo = payinfo
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getAddress: function () {
      try {
        let data = {}
        Promise.resolve(this.$GET('patient/getAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.addresses = res.response
            if (this.isAddressActiveId === 0) {
              _.each(res.response, function (addresses) {
                if (this.selectedLocality.locationId === addresses.Location.locationId) {
                  if (this.isAddressActiveId > 0) {
                    return false
                  }
                  this.activeAddress = addresses
                  this.$localStorage.set('sa', addresses, 30 * 60 * 1000)
                  this.isAddressActiveId = addresses.addressId
                }
              }, this)
              return false
            }
            _.each(res.response, function (element) {
              if (element.addressId === this.isAddressActiveId) {
                if ((element.Location.CityControl.cityId === this.$localStorage.get('sc').cityId)) {
                  this.activeAddress = element
                  this.$localStorage.set('sa', element, 30 * 60 * 1000)
                  this.isAddressActiveId = element.addressId
                } else {
                  this.activeAddress = undefined
                  this.$localStorage.remove('sa')
                  this.isAddressActiveId = 0
                }
              }
            }, this)
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    getMembers: function () {
      try {
        let data = {}
        Promise.resolve(this.$GET('patient/getUserAndFamily', data)).then(function (res) {
          this.members = res.response
          if (res.response.user) {
            if (this.$localStorage.get('sm')) {
              if (this.$localStorage.get('sm').userId === undefined) {
                this.isMemberActiveId = this.$localStorage.get('sm').memberId
                this.isMe = false
              } else {
                this.isMemberActiveId = this.$localStorage.get('sm').userId
                this.isMe = true
              }
            } else {
              this.isMemberActiveId = res.response.user.userId
              this.$localStorage.set('sm', res.response.user, 30 * 60 * 1000)
              this.isMe = true
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    addMember: function () {
      this.addMemberFields = {
        firstName: '',
        lastName: '',
        sex: 'M',
        age: '',
        mobile: ''
      }
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 200)
      this.editMemberForm = false
      this.addAddressForm = false
      this.editAddressForm = false
      $('#addPatientProfileModal').modal('show')
    },
    editMemberProfile: function (type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('show')
        this.getProfile()
      }
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') !== '') {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data))
          .then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                _.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address
                  }
                })
              }
              this.editMemberObj['firstName'] = res.response.Patient.firstName
              this.editMemberObj['lastName'] = res.response.Patient.lastName
              this.editMemberObj['email'] = res.response.email
              this.editMemberObj['phone1'] = res.response.Patient.phone1
              this.editMemberObj['phone2'] = res.response.Patient.phone2
              this.editMemberObj['dob'] = res.response.Patient.dob ? res.response.Patient.dob : undefined
              this.editMemberObj['sex'] = res.response.Patient.sex

              this.profileDetails['username'] = res.response.Patient.firstName + ' ' + res.response.Patient.lastName
              this.profileDetails['firstName'] = res.response.Patient.firstName
              this.profileDetails['lastName'] = res.response.Patient.lastName
              this.profileDetails['photo'] = res.response.Patient.photo
              this.profileDetails['dob'] = dateFormat(res.response.Patient.dob, 'dd-mm-yyyy')
              this.profileDetails['phone1'] = res.response.Patient.phone1
              this.profileDetails['phone2'] = res.response.Patient.phone2
              this.profileDetails['sex'] = res.response.Patient.sex
              this.profileDetails['email'] = res.response.email
              if (res.response.Patient.dob) {
                this.profileDetails['age'] = this.calculateAge(new Date(res.response.Patient.dob))
              } else {
                this.profileDetails['age'] = 0
              }
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                let dob = (res.response.Patient.dob).split('T')
                let dobDate = dob[0].split('-')
                this.year = dobDate[0]
                this.month = dobDate[1]
                this.getNumberOfDays(dobDate[2])
              }
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    },
    saveProfile: function () {
      this.isDobError = false
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          if (this.year.length !== 4 || this.month.length <= 0 || this.ddate.length <= 0) {
            this.isDobError = true
            return false
          }
          try {
            var data = {
              'firstName': this.editMemberObj.firstName,
              'lastName': this.editMemberObj.lastName,
              'phone1': this.editMemberObj.phone1,
              'phone2': this.editMemberObj.phone2,
              'photo': '',
              'sex': this.editMemberObj.sex,
              'dob': this.year + '-' + this.month + '-' + this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            }
            Promise.resolve(this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile')
                var userDetails = {
                  'username': this.editMemberObj.firstName + ' ' + this.editMemberObj.lastName,
                  'firstName': this.editMemberObj.firstName,
                  'lastName': this.editMemberObj.lastName,
                  'phone1': this.editMemberObj.phone1,
                  'dob': dateFormat(this.editMemberObj.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                }
                this.$localStorage.set('profile', userDetails, 0)
                this.getMembers()
                $('#editMemberProfileModal').modal('hide')
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:saveProfile', e)
          }
        }
      })
    },
    editMember: function (family) {
      this.addAddressForm = false
      this.editAddressForm = false
      this.addMemberForm = false
      this.editMemberFields = family
      $('#editPatientProfileModal').modal('show')
    },
    cancelMember: function (type) {
      if (type === 1) {
        $('#editMemberProfileModal').modal('hide')
      } else if (type === 2) {
        $('#editPatientProfileModal').modal('hide')
        this.editMemberFields = {}
      } else if (type === 3) {
        $('#addPatientProfileModal').modal('hide')
        this.addMemberFields = {
          firstName: '',
          lastName: '',
          sex: 'M',
          age: ''
        }
      }
      this.errors.items = []
      return false
    },
    saveMember: function () {
      try {
        this.$validator.validateAll('addMember').then((result) => {
          if (result) {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                firstName: this.addMemberFields.firstName,
                lastName: this.addMemberFields.lastName,
                sex: this.addMemberFields.sex,
                mobile: this.addMemberFields.mobile,
                age: this.addMemberFields.age
              }
              Promise.resolve(this.$POST('patient/saveFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000)
                  this.isMe = false
                  this.getMembers()
                  this.addMemberForm = false
                  this.editMemberForm = false
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.addMemberFields = {}
                  this.errors.items = []
                  $('#addPatientProfileModal').modal('hide')
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    setActiveMemberId: function (member) {
      if (member.userId) {
        this.isMe = true
      } else {
        this.isMe = false
      }
      this.$localStorage.set('sm', member, 30 * 60 * 1000)
    },
    deleteMember: function (member) {
      try {
        let confirmMemberFn = function () {
          if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
            var data = {
              memberId: member.memberId
            }
            Promise.resolve(this.$POST('patient/deleteFamilyMember', data)).then(function (res) {
              if (res.response_code === 0) {
                this.getMembers()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }.bind(this)
        this.$Simplert.open({
          title: 'Confirm',
          message: 'Are you sure confirm, you want to delete this member?',
          type: 'info',
          useConfirmBtn: true,
          onConfirm: confirmMemberFn,
          customConfirmBtnText: 'Ok',
          customCloseBtnText: 'Cancel',
          disableOverlayClick: true
        })
      } catch (e) {
        console.log(e)
      }
    },
    updateMember: function () {
      try {
        this.$validator.validateAll('editMember').then((result) => {
          if (result) {
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              var data = {
                memberId: this.editMemberFields.memberId,
                firstName: this.editMemberFields.firstName,
                lastName: this.editMemberFields.lastName,
                sex: this.editMemberFields.sex,
                mobile: this.editMemberFields.mobile,
                age: this.editMemberFields.age
              }
              Promise.resolve(this.$POST('patient/updateFamilyMember', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.$localStorage.set('sm', res.response, 30 * 60 * 1000)
                  this.isMemberActiveId = this.$localStorage.get('sm').memberId
                  this.isMe = false
                  this.getMembers()
                  this.addMemberForm = false
                  this.editMemberForm = false
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.editMemberFields = {}
                  $('#editPatientProfileModal').modal('hide')
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    selectAddress: function (address) {
      if (address.Location.CityControl.cityId === this.$localStorage.get('location').CityControl.cityId) {
        this.isAddressActiveId = address.addressId
        this.$localStorage.set('sa', address, 30 * 60 * 1000)
      } else {
        let SecAlertObj = {}
        SecAlertObj = {
          title: 'Alert',
          message: `The selected pickup address city (${address.Location.CityControl.cityName}) is not within the searched city (${this.$localStorage.get('location').CityControl.cityName}). Kindly provide the correct address.`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        }
        this.$Simplert.open(SecAlertObj)
      }
    },
    saveAddress: function () {
      try {
        this.isInvalidPincode = false
        this.$validator.validateAll('addAddress').then((result) => {
          if (result) {
            if (this.addAddressFields.zipcode && this.addAddressFields.zipcode.length > 0 && !this.addAddressFields.locality && this.addAddressFields.locality !== 'OTHER') {
              this.isInvalidPincode = true
              return false
            }
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'addressName': this.addAddressFields.addressName,
                'flatNo': this.addAddressFields.flatNo,
                'address': this.addAddressFields.address,
                'landmark': this.addAddressFields.landmark,
                'locationOther': (this.addAddressFields.locationOther) ? this.addAddressFields.locationOther : '',
                'mobile': this.addAddressFields.mobile,
                'isDefault': 0,
                'coordinates': this.mapCoordinates
              }
              if (this.addAddressFields.locality === 'OTHER') {
                data['locationId'] = 0
                data['cityId'] = this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 2
                data['stateId'] = this.$localStorage.get('sc') ? (this.$localStorage.get('sc').State ? this.$localStorage.get('sc').State.stateId : 2) : 2
                data['zipCode'] = this.addAddressFields.locationPincode
                if (isNaN(this.addAddressFields.locationPincode)) {
                  this.otherPincodeError = true
                  return false
                }
              } else {
                data['locationId'] = this.addAddressFields.locality.locationId
                data['cityId'] = this.addAddressFields.locality.City.cityId
                data['stateId'] = this.addAddressFields.locality.State.stateId
                data['zipCode'] = this.addAddressFields.locality.locationZipCode
              }
              Promise.resolve(this.$POST('patient/saveAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.activeAddress = res.response
                  this.$localStorage.set('sa', res.response, 30 * 60 * 1000)
                  this.isAddressActiveId = res.response.addressId
                  this.getAddress()
                  this.addAddressFields = {}
                  $('#addAddressModal').modal('hide')
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: `<div style="text-align: left; line-height: 20px;">
                              <p>${res.response_message}</p>
                            </div>`,
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  })
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    updateAddress: function () {
      try {
        this.isInvalidPincode = false
        this.$validator.validateAll('editAddress').then((result) => {
          if (result) {
            if (this.editAddressFields.zipcode && this.editAddressFields.zipcode.length > 0 && !this.editAddressFields.locality && this.editAddressFields.locality !== 'OTHER') {
              this.isInvalidPincode = true
              return false
            }
            if (this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
              let data = {
                'addressId': this.editAddressFields.addressId,
                'addressName': this.editAddressFields.addressName,
                'address': this.editAddressFields.address,
                'flatNo': this.editAddressFields.flatNo,
                'landmark': this.editAddressFields.landmark,
                'locationOther': (this.editAddressFields.locationOther) ? this.editAddressFields.locationOther : '',
                'mobile': this.editAddressFields.mobile,
                'isDefault': 0,
                'coordinates': this.mapCoordinates
              }
              if (this.editAddressFields.locality === 'OTHER') {
                data['locationId'] = 0
                data['cityId'] = this.$localStorage.get('sc') ? this.$localStorage.get('sc').cityId : 0
                data['stateId'] = this.$localStorage.get('sc') ? (this.$localStorage.get('sc').State ? this.$localStorage.get('sc').State.stateId : 2) : 2
                data['zipCode'] = this.editAddressFields.locationPincode
              } else {
                data['locationId'] = this.editAddressFields.locality.locationId
                data['cityId'] = this.editAddressFields.locality.City.cityId
                data['stateId'] = this.editAddressFields.locality.State.stateId
                data['zipCode'] = this.editAddressFields.locality.locationZipCode
              }
              Promise.resolve(this.$POST('patient/updateAddress', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.isAddressActiveId = this.editAddressFields.addressId
                  this.getAddress()
                  this.addAddressForm = false
                  this.editAddressForm = false
                  this.editAddressFields = {}
                  $('#editAddressModal').modal('hide')
                } else {
                  this.$Simplert.open({
                    title: 'Information',
                    message: `<div style="text-align: left; line-height: 20px;">
                              <p>${res.response_message}</p>
                            </div>`,
                    type: 'info',
                    useConfirmBtn: false,
                    customCloseBtnText: 'Ok',
                    disableOverlayClick: true
                  })
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        })
      } catch (e) {
        console.log('error', e)
      }
    },
    addAddress: function (value) {
      this.isInvalidPincode = false
      this.addMemberForm = false
      this.editMemberForm = false
      this.addAddressForm = false
      this.editAddressForm = false
      this.showLocOther = false
      let addFields = []
      this.addressZipCode = ''
      addFields['addressId'] = ''
      addFields['addressName'] = this.$localStorage.get('profile').username
      addFields['address'] = ''
      addFields['zipcode'] = this.$localStorage.get('location') ? (this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode) : ''
      addFields['locationOther'] = ''
      addFields['mobile'] = this.$localStorage.get('profile').phone1
      addFields['isDefault'] = 0
      addFields['coordinates'] = ''
      addFields['state'] = undefined

      if (this.$localStorage.get('location') && this.$localStorage.get('location').City && this.$localStorage.get('location').State) {
        addFields['cityId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').City.cityId : 2
        addFields['stateId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').State.stateId : 2
        addFields['locationId'] = (this.$localStorage.get('location')) ? this.$localStorage.get('location').locationId : 0
        addFields['stateCityDisp'] = this.$localStorage.get('location').City.cityName + ', ' + this.$localStorage.get('location').State.stateName
        addFields['locality'] = this.$localStorage.get('location')
        this.stateCityDisp = addFields['stateCityDisp']
      } else {
        addFields['locality'] = ''
      }
      this.addAddressFields = addFields
      this.mapWithAddressAdd(this.addAddressFields, 2)
      setTimeout(function () {
        $('#addAddressModal').modal('show')
      }, 300)
    },
    isNumber: function (evt) {
      if (!evt) {
        evt = window.event
      }
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        setTimeout(function () {
          this.onchangePincode()
        }.bind(this), 300)
        return true
      }
    },
    onchangePincode: function () {
      if (this.addAddressFields.zipcode.length !== 6) {
        return false
      }
      var data = {
        'pincode': this.addAddressFields.zipcode
      }
      Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response
        } else {
          this.locationList = []
          this.addAddressFields.locality = ''
        }
      }.bind(this))
    },
    isNumberEdit: function (evt) {
      if (!evt) {
        evt = window.event
      }
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onchangePincodeEdit: function () {
      if (this.editAddressFields.zipcode.length !== 6) {
        return false
      }
      var data = {
        'pincode': this.editAddressFields.zipcode
      }
      Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        if (res.response.length > 0) {
          this.locationList = res.response
        } else {
          this.locationList = []
          this.editAddressFields.locality = ''
        }
      }.bind(this))
    },
    cancelModalPopup: function () {
      $('#addAddressModal').modal('hide')
      $('#editAddressModal').modal('hide')
      this.errors.items = []
      this.addAddressFields = {}
      this.editAddressFields = {}
      this.addAddressForm = false
      this.editAddressForm = false
    },
    addressChanged: function (type) {
      if (type === 1) {
        this.mapWithAddressAdd(this.addAddressFields, 2)
      } else {
        this.mapWithAddressEdit(this.editAddressFields, 2)
      }
    },
    editAddress: function (value) {
      try {
        // if (value.Location.CityControl.cityId !== this.$localStorage.get('sc').cityId) {
        //     let SecAlertObj = {
        //       title: 'Alert',
        //       message: `This address belongs to ${value.Location.CityControl.cityName} city. Please choose another or add new address.`,
        //       type: 'warning',
        //       disableOverlayClick: true,
        //       showXclose: true,
        //       useConfirmBtn: false,
        //       customCloseBtnText: 'OK'
        //     }
        //     this.$Simplert.open(SecAlertObj)
        //     return false
        // }
        this.isInvalidPincode = false
        this.addMemberForm = false
        this.editMemberForm = false
        this.addAddressForm = false
        this.editAddressForm = false
        this.showLocOther = false
        let editFields = []
        editFields['addressId'] = value.addressId
        editFields['addressName'] = value.addressName
        editFields['address'] = value.address
        editFields['flatNo'] = value.flatNo
        editFields['landmark'] = value.landmark
        editFields['zipcode'] = value.Location.locationName + '-' + value.Location.locationZipCode
        editFields['locationOther'] = ''
        editFields['mobile'] = value.mobile
        editFields['isDefault'] = 0
        editFields['coordinates'] = value.coordinates
        editFields['state'] = undefined
        editFields['locality'] = value.Location
        this.mapWithAddressEdit(value, 1)
        setTimeout(function () {
          $('#editAddressModal').modal('show')
        }, 500)
        editFields['cityId'] = (value.Location) ? value.Location.City.cityId : 2
        editFields['stateId'] = (value.Location) ? value.Location.State.stateId : 2
        editFields['locationId'] = (value.Location) ? value.Location.locationId : 0
        editFields['stateCityDisp'] = value.Location.City.cityName + ', ' + value.Location.State.stateName
        this.editAddressFields = editFields
        this.stateCityDisp = editFields['stateCityDisp']
        // var data = {
        //   'pincode': value.zipCode
        // }
        // Promise.resolve(this.$GET('patient/getAddressByPincode', data)).then(function (res) {
        //   if (res.response.length > 0) {
        //     this.locationList = res.response
        //     _.each(res.response, function (element) {
        //       if (element.locationId === value.Location.locationId) {
        //         editFields['cityId'] = (element) ? element.City.cityId : 2
        //         editFields['stateId'] = (element) ? element.State.stateId : 2
        //         editFields['locationId'] = (element) ? element.locationId : 0
        //         editFields['stateCityDisp'] = element.City.cityName + ', ' + element.State.stateName
        //         // myMap(undefined, 'map', 'coordinates_popup', this.editAddressFields.coordinates)
        //         if (element) {
        //           editFields['locality'] = element
        //         } else {
        //           editFields['locality'] = ''
        //         }
        //       }
        //     }, this)
        //     // this.editAddressForm = true
        //     this.editAddressFields = editFields
        //     this.stateCityDisp = editFields['stateCityDisp']
        //   }
        // }.bind(this)).catch(function (err) {
        //   console.error(err)
        // })
      } catch (e) {
        console.log('error', e)
      }
    },
    mapWithAddressAdd: function (value, type) {
      this.mapCoordinates = undefined
      var address = ''
      var location = ''
      var stateCity = value.stateCityDisp
      this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      })
      if (type === 2) {
        address = value.address
        if (value.locality === 'OTHER') {
          location = value.locationOther
        } else {
          location = value.locality.locationName
        }
        this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var geocoder = new google.maps.Geocoder()
        geocoder.geocode({
          'address': address && location ? address + ' , ' + location + ', ' + stateCity : (address && !location ? address + ', ' + stateCity : (!address && location ? location + ', ' + stateCity : ''))
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            })
            var latitude = results[0].geometry.location.lat()
            var longitude = results[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            this.mapCoordinates = latitude + ',' + longitude
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
          } else {
            this.map = new google.maps.Map(document.getElementById('myMapAdd'), {
              zoom: 15,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            })
            geocoder.geocode({'address': location + ', ' + stateCity}, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location)
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                })
                var latitude = resp[0].geometry.location.lat()
                var longitude = resp[0].geometry.location.lng()
                var latlng = new google.maps.LatLng(latitude, longitude)
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize')
                  this.map.setCenter(latlng)
                  google.maps.event.trigger(this.map, 'resize')
                }.bind(this), 1000)
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
              } else {
                geocoder.geocode({
                  'address': stateCity
                }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location)
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    })
                    var latitude = resp[0].geometry.location.lat()
                    var longitude = resp[0].geometry.location.lng()
                    var latlng = new google.maps.LatLng(latitude, longitude)
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize')
                      this.map.setCenter(latlng)
                      google.maps.event.trigger(this.map, 'resize')
                    }.bind(this), 1000)
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status)
                  }
                }.bind(this))
              }
            }.bind(this))
          }
        }.bind(this))
      } else {
        var geocoder = new google.maps.Geocoder()
        geocoder.geocode({
          'address': stateCity
        }, function (resp, status) {
          if (status === 'OK') {
            this.map.setCenter(resp[0].geometry.location)
            this.marker = new google.maps.Marker({
              map: this.map,
              position: resp[0].geometry.location
            })
            var latitude = resp[0].geometry.location.lat()
            var longitude = resp[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
            this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
          } else {
            console.log('Geocode was not successful for the following reason: ' + status)
          }
        }.bind(this))
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng
        })
        this.marker.setMap(this.map)
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng()
      }.bind(this))
    },
    mapWithAddressEdit: function (value, type) {
      this.mapCoordinates = undefined
      var address = ''
      var location = ''
      var city = value.City ? value.City.cityName : ''
      var state = value.State ? value.State.stateName : ''
      var stateCity = city + ', ' + state
      if (type === 1) {
        address = value.address
        location = value.Location.locationName
        this.mapCoordinates = value.coordinates
      } else {
        address = value.address
        if (value.locality === 'OTHER') {
          location = value.locationOther
        } else {
          location = value.locality.locationName
        }
      }
      if (this.mapCoordinates && this.mapCoordinates.length > 0) {
        var cordinatesArray = this.mapCoordinates.split(',')
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var latitude = parseFloat(cordinatesArray[0], 8)
        var longitude = parseFloat(cordinatesArray[1], 8)
        var latlng = new google.maps.LatLng(latitude, longitude)
        this.marker = new google.maps.Marker({
          map: this.map,
          position: latlng
        })
        setTimeout(function () {
          this.map.setCenter(latlng)
          google.maps.event.trigger(this.map, 'resize')
          this.map.setCenter(latlng)
          google.maps.event.trigger(this.map, 'resize')
        }.bind(this), 1000)
      } else {
        this.map = new google.maps.Map(document.getElementById('myMapVal'), {
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
        var geocoder = new google.maps.Geocoder()

        geocoder.geocode({
          'address': address + ' , ' + location + ', ' + stateCity
        }, function (results, status) {
          if (status === 'OK') {
            this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
            })
            var latitude = results[0].geometry.location.lat()
            var longitude = results[0].geometry.location.lng()
            var latlng = new google.maps.LatLng(latitude, longitude)
            this.mapCoordinates = latitude + ',' + longitude
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize')
              this.map.setCenter(latlng)
              google.maps.event.trigger(this.map, 'resize')
            }.bind(this), 1000)
          } else {
            geocoder.geocode({'address': location + ', ' + stateCity}, function (resp, status) {
              if (status === 'OK') {
                this.map.setCenter(resp[0].geometry.location)
                this.marker = new google.maps.Marker({
                  map: this.map,
                  position: resp[0].geometry.location
                })
                var latitude = resp[0].geometry.location.lat()
                var longitude = resp[0].geometry.location.lng()
                var latlng = new google.maps.LatLng(latitude, longitude)
                setTimeout(function () {
                  google.maps.event.trigger(this.map, 'resize')
                  this.map.setCenter(latlng)
                  google.maps.event.trigger(this.map, 'resize')
                }.bind(this), 1000)
                this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
              } else {
                geocoder.geocode({ 'address': stateCity }, function (resp, status) {
                  if (status === 'OK') {
                    this.map.setCenter(resp[0].geometry.location)
                    this.marker = new google.maps.Marker({
                      map: this.map,
                      position: resp[0].geometry.location
                    })
                    var latitude = resp[0].geometry.location.lat()
                    var longitude = resp[0].geometry.location.lng()
                    var latlng = new google.maps.LatLng(latitude, longitude)
                    setTimeout(function () {
                      google.maps.event.trigger(this.map, 'resize')
                      this.map.setCenter(latlng)
                      google.maps.event.trigger(this.map, 'resize')
                    }.bind(this), 1000)
                    this.mapCoordinates = this.map.center.lat() + ',' + this.map.center.lng()
                  } else {
                    console.log('Geocode was not successful for the following reason: ' + status)
                  }
                }.bind(this))
              }
            }.bind(this))
          }
        }.bind(this))
      }
      google.maps.event.addListener(this.map, 'click', function (event) {
        this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng
        })
        this.marker.setMap(this.map)
        this.mapCoordinates = event.latLng.lat() + ',' + event.latLng.lng()
      }.bind(this))
    },
    showAddOtherLocation: function () {
      this.showLocOther = false
      if (this.addAddressFields.locality === 'OTHER') {
        this.showLocOther = true
        this.stateCityDisp = this.$localStorage.get('sc').cityName + ', ' + this.$localStorage.get('sc').State.stateName
      } else {
        let jsonLocality = this.addAddressFields.locality
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName
      }
      this.mapWithAddressAdd(this.addAddressFields, 2)
    },
    showEditOtherLocation: function () {
      this.showLocOther = false
      if (this.editAddressFields.locality === 'OTHER') {
        this.showLocOther = true
        this.stateCityDisp = this.stateCityDisp
      } else {
        let jsonLocality = this.editAddressFields.locality
        this.stateCityDisp = jsonLocality.City.cityName + ', ' + jsonLocality.State.stateName
      }
      this.mapWithAddressEdit(this.editAddressFields, 2)
    },
    deleteAddress: function (addressId) {
      let confirmFn = function () {
        let data = {
          addressId: addressId
        }
        Promise.resolve(this.$POST('patient/deleteAddress', data)).then(function (res) {
          if (res.response.length > 0) {
            this.getAddress()
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      }.bind(this)
      let obj = {}
      obj = {
        title: 'Confirm',
        message: 'Are you sure confirm, you want to delete this address?',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Ok',
        customCloseBtnText: 'Cancel',
        disableOverlayClick: true
      }
      this.$Simplert.open(obj)
    },
    applyCoupon: function () {
      this.$validator.validateAll('coupon').then((result) => {
        if (result) {
          try {
            this.couponError = ''
            this.isSuccessCoupon = false
            if (this.couponCode === '') {
              this.couponError = 'Please enter coupon code'
              return false
            }
            let data = {
              'coupon_code': (this.couponCode).toUpperCase()
            }

            if (this.$localStorage.get('sl')) {
              data['labId'] = this.$localStorage.get('sl').labId
              let labProfileIds = []
              if (this.$localStorage.get('sl') && this.$localStorage.get('sl').labTestList.length > 0) {
                this.$localStorage.get('sl').labTestList.forEach(function (element) {
                  if (element.labProfileId > 0) {
                    labProfileIds.push(element.labProfileId)
                  }
                })
              }
              data['labProfileIds'] = labProfileIds
            } else {
              data['labId'] = 0
              data['labProfileIds'] = []
            }

            if (this.$localStorage.get('profile')) {
              data['email'] = this.$localStorage.get('profile').email
            } else {
              data['email'] = ''
            }
            Promise.resolve(this.$POST('patient/applyCoupon', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.set('cou', res.response, 30 * 60 * 1000)
                this.isCouponApplied = true
                this.couponData = res.response
                this.couponError = ''
                if (res.response.coupon_percentage > 0) {
                  this.isSuccessCoupon = true
                  this.couponError = res.response.coupon_percentage + '% '
                } else {
                  this.isSuccessCoupon = true
                  this.couponError = 'Rs.' + res.response.coupon_price + ' '
                }
                this.getCartPaymentDetails()
              } else {
                this.$localStorage.remove('cou')
                if (res.response_code === 4) {
                  this.couponError = res.response_message + ' (Rs.' + res.response.coupon_range + ')'
                } else {
                  this.couponError = res.response_message
                }
                this.getCartPaymentDetails()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.log('error', e)
          }
        }
      })
    },
    removeCoupon: function () {
      this.$localStorage.remove('cou')

      if(this.redeemCredits)
      this.redeemCreditPoints = this.payinfo.creditPoints
      else
      this.redeemCreditPoints = 0

      this.getCartPaymentDetails()
      this.isCouponApplied = false
      this.couponData = undefined
      this.couponCode = ''
    },
    getCartPaymentDetails: function (isFirst) {
      try {
        let labTestCosts = []
        if (this.$localStorage.get('sl')) {
          if ((this.$localStorage.get('sl').labTestList).length > 0) {
            _.each(this.$localStorage.get('sl').labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        var data = {
          'labId': (this.$localStorage.get('sl')) ? this.$localStorage.get('sl').labId : '0',
          'labTests': labTestCosts,
          'couponCode': (this.$localStorage.get('cou')) ? this.$localStorage.get('cou').coupon_code : '',
          'couponId': (this.$localStorage.get('cou')) ? this.$localStorage.get('cou').couponId : '0'
        }
        Promise.resolve(this.$POST('patient/cartPaymentDetails', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              let payinfo = {}
              payinfo['mrpTotal'] = res.response.mrpTotal
              payinfo['phlebotomistFee'] = res.response.phlebotomistFee
              payinfo['subTotal'] = res.response.subTotal
              payinfo['labDiscount'] = res.response.labDiscount
              payinfo['waiverDiscountApplyFee'] = res.response.waiverDiscountApplyFee
              payinfo['phlebotomyFeeWaiver'] = res.response.phlebotomyFeeWaiver
              payinfo['total'] = (res.response.mrpTotal - res.response.labDiscount) // res.response.total
              payinfo['gst'] = res.response.gst
              payinfo['couponFee'] = res.response.couponFee
              payinfo['grandTotal'] = res.response.grandTotal
              payinfo['grandTotalStrike'] = res.response.grandTotalStrike
              payinfo['couponCode'] = res.response.couponCode
              payinfo['couponId'] = res.response.couponId
              payinfo['ourPrice'] = res.response.ourPrice
              if ((res.response.grandTotal) <= 0) {
                this.payinfo.grandTotal = 0
                payinfo['grandTotal'] = 0
              }
              payinfo['priceDetails'] = res.response.priceDetails
              payinfo['creditPoints'] = res.response.creditPoints
              this.payinfo = payinfo
              if(isFirst && this.payinfo.creditPoints && this.payinfo.creditPoints > 0){
                this.redeemCredits = true
              }
            }
          }
          this.$hidePageLoading()
          this.creditPointChanged()
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    razorPayAssign: function (data) {
        var self = this
        var options = {
          'key': this.$razorpay_key,
          'amount': Math.ceil(data.request.totalCost) * 100, // 2000 paise = INR 20
          'name': 'Labotist Private Limited',
          'description': 'Health & Fitness',
          'image': 'https://labotist.com/dist/images/logo-svg.svg',
          'handler': function (response) {
            // alert(response.razorpay_payment_id)
            self.updateRequest(response)
          },
          'prefill': {
            'name': data.request.reqPatientFirstName + ' ' + data.request.reqPatientLastName,
            'email': data.request.reqPatientEmail,
            'contact': data.request.reqPatientMobile
          },
          'notes': {
            'address': data.request.pickupAddress,
            'requestId': data.request.requestId
          },
          'theme': {
            'color': '#057dc2',
            'emi_mode': false
          },
          order_id : data.order.id
        }
        Razorpay(options).open()
    },
    saveRequest: function (paymentId) {
      this.$showPageLoading()
      try {
        let paymentData = {
          paymentId: paymentId
        }
        Promise.resolve(this.$GET('payment/fetch', paymentData)).then(function (rzpInfo) {
          if (rzpInfo.response_code === 0) {
            let totalPaidCost = 0
            if (rzpInfo) {
              totalPaidCost = (rzpInfo.response.amount) / 100
            }
            let timezone = new Date().getTimezoneOffset()
            let appointmentDate = this.$localStorage.get('ct').dateFormatMoment
            let appointmentTimeFrom = this.$localStorage.get('ct').startTime
            let appointmentTimeTo = this.$localStorage.get('ct').endTime
            let appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime
            let appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime
            let addressForRequest = '';
            if(this.$localStorage.get('sa').flatNo) {
               addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
            }

            addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

            if(this.$localStorage.get('sa').landmark) {
              addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
            }

            let data = {
              'paymentId': paymentId,
              'labId': this.$localStorage.get('sl').labId,
              'branchId': this.$localStorage.get('sl').branchId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': totalPaidCost,
              'actualCost': this.payinfo.subTotal,
              'discountCost': (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver),
              'gstCost': (this.payinfo.gstCost),
              'couponCost': (this.payinfo.couponFee),
              'couponCode': (this.payinfo.couponCode),
              'couponId': (this.payinfo.couponId),
              'totalCost': (this.payinfo.grandTotal),
              'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sa').mobile,
              'pickupAddress': addressForRequest +  this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates
            }

            let labTests = []
            let labProfiles = []
            if (this.$localStorage.get('st').length > 0) {
              _.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId)
                } else {
                  labTests.push(element.testId)
                }
              })
            }
            data.test = labTests
            data.profile = labProfiles
            Promise.resolve(this.$POST('patient/saveRequest', data)).then(function (res) {
              if (res.response_code === 0) {
                this.clearRequestSessions()
                global.successId = res.response.requestId
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                })
                this.$router.push({ path: '/success', params: { sample: 'hi' } })
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err)
            })
          }
        }.bind(this)).catch(function (err) {
          console.log('METHOD:saveRequest', err)
        })
      } catch (err) {
        console.log('METHOD:saveRequest', err)
      }
    },
    updateRequest: function (payment) {
      this.$showPageLoading()
      try {
        let data = {
          orderId : payment.razorpay_order_id,
          paymentId : payment.razorpay_payment_id
        }
        setTimeout(function(){
          Promise.resolve(this.$POST('patient/updateRequest', data)).then(function (res) {
            if (res.response_code === 0) {
              global.successId = res.response.requestId
              try{
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'PAYMENT COMPLETED',
                  contents: '',
                  content_type: 'PAYMENT_COMPLETED'
                })
              } catch(err) {
                console.log(err)
              }
              this.$router.push({ path: '/success', params: { sample: 'hi' } })
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:saveRequest', err)
          })
        }.bind(this), 2000)
      } catch (err) {
        console.log('METHOD:saveRequest', err)
      }
    },
    saveRequestFirst: function () {
      this.$showPageLoading()
      try {
            let timezone = new Date().getTimezoneOffset()
            let appointmentDate = this.$localStorage.get('ct').dateFormatMoment
            let appointmentTimeFrom = this.$localStorage.get('ct').startTime
            let appointmentTimeTo = this.$localStorage.get('ct').endTime
            let appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime
            let appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime
            let addressForRequest = '';
            if(this.$localStorage.get('sa').flatNo) {
               addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
            }

            addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

            if(this.$localStorage.get('sa').landmark) {
              addressForRequest = addressForRequest + this.$localStorage.get('sa').landmark + ', ';
            }
            let data = {
              'labId': this.$localStorage.get('sl').labId,
              'branchId': this.$localStorage.get('sl').branchId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': 0,
              'actualCost': this.payinfo.subTotal,
              'discountCost': (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver),
              'gstCost': (this.payinfo.gstCost),
              'couponCost': (this.payinfo.couponFee),
              'couponCode': (this.payinfo.couponCode),
              'couponId': (this.payinfo.couponId),
              'totalCost': (this.payinfo.grandTotal),
              'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sm').mobile,
              'pickupAddress': addressForRequest +  this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates,
              'redeemCredits': this.redeemCredits,
              'redeemCreditPoints': this.redeemCreditPoints,
            }
            
            let labTests = []
            let labProfiles = []
            if (this.$localStorage.get('st').length > 0) {
              _.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId)
                } else {
                  labTests.push(element.testId)
                }
              })
            }
            data.test = labTests
            data.profile = labProfiles
            Promise.resolve(this.$POST('patient/saveRequestBeforePayment', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$hidePageLoading()
                this.razorPayAssign(res.response)
              } else if(res.response_code === 4) {
                this.$hidePageLoading()
                this.$Simplert.open({
                  title: 'Information',
                  message: `<div style="text-align: left; line-height: 20px;">
                            <p>${res.response_message}</p>
                          </div>`,
                  type: 'info',
                  useConfirmBtn: false,
                  customCloseBtnText: 'Ok',
                  disableOverlayClick: true
                })
                this.getCartPaymentDetails()
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err)
            })
      }catch(err){

      }
    },
    saveRequestCash: function (zeroPayment) {
      this.$showPageLoading()
      try {
            let timezone = new Date().getTimezoneOffset()
            let appointmentDate = this.$localStorage.get('ct').dateFormatMoment
            let appointmentTimeFrom = this.$localStorage.get('ct').startTime
            let appointmentTimeTo = this.$localStorage.get('ct').endTime
            let appointmentDateTimeFrom = this.$localStorage.get('ct').fromDateTime
            let appointmentDateTimeTo = this.$localStorage.get('ct').toDateTime
            let addressForRequest = '';
            if(this.$localStorage.get('sa').flatNo) {
               addressForRequest = addressForRequest + this.$localStorage.get('sa').flatNo + ', ';
            }

            addressForRequest = addressForRequest + this.$localStorage.get('sa').address + ', ';

            if(this.$localStorage.get('sa').landmark) {
              addressForRequest = addressForRequest + ', ' + this.$localStorage.get('sa').landmark + ', ';
            }
            let data = {
              'labId': this.$localStorage.get('sl').labId,
              'branchId': this.$localStorage.get('sl').branchId,
              'appointmentDate': appointmentDate,
              'appointmentTimeFrom': appointmentTimeFrom,
              'appointmentTimeTo': appointmentTimeTo,
              'appointmentDateTimeFrom': appointmentDateTimeFrom,
              'appointmentDateTimeTo': appointmentDateTimeTo,
              'timezone': timezone,
              'pickupAddressId': this.$localStorage.get('sa').addressId,
              'pickupLocation': this.$localStorage.get('sa').Location.locationName,
              'pickupZipcode': this.$localStorage.get('sa').zipCode,
              'totalPaidCost': 0,
              'actualCost': this.payinfo.subTotal,
              'discountCost': (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver),
              'gstCost': (this.payinfo.gstCost),
              'couponCost': (this.payinfo.couponFee),
              'couponCode': (this.payinfo.couponCode),
              'couponId': (this.payinfo.couponId),
              'totalCost': (this.payinfo.grandTotal),
              'memberId': this.$localStorage.get('sm').memberId ? this.$localStorage.get('sm').memberId : 0,
              'reqPatientFirstName': this.$localStorage.get('sm').firstName,
              'reqPatientLastName': this.$localStorage.get('sm').lastName,
              'reqPatientSex': this.$localStorage.get('sm').sex,
              'reqPatientAge': this.$localStorage.get('sm').age,
              'reqPatientEmail': this.profileDetails.email,
              'reqPatientMobile': this.$localStorage.get('sm').mobile,
              // 'pickupAddress': this.$localStorage.get('sa').address + ', ' + this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupAddress': addressForRequest +  this.$localStorage.get('sa').Location.locationName + ', ' + this.$localStorage.get('sa').City.cityName + ', ' + this.$localStorage.get('sa').State.stateName + ' - ' + this.$localStorage.get('sa').zipCode,
              'pickupCoordinates': this.$localStorage.get('sa').coordinates,
              'paymentType': zeroPayment ? 0 : 1,
              'redeemCredits': this.redeemCredits,
              'redeemCreditPoints': this.redeemCreditPoints,
            }
            
            let labTests = []
            let labProfiles = []
            if (this.$localStorage.get('st').length > 0) {
              _.each(this.$localStorage.get('st'), function (element) {
                if (element.panelId > 0) {
                  labProfiles.push(element.panelId)
                } else {
                  labTests.push(element.testId)
                }
              })
            }
            data.test = labTests
            data.profile = labProfiles
            Promise.resolve(this.$POST('patient/saveRequestCash', data)).then(function (res) {
              if (res.response_code === 0) {
                global.successId = res.response.requestId
                try{
                  Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'PAYMENT COMPLETED',
                    contents: '',
                    content_type: 'PAYMENT_COMPLETED'
                  })
                } catch(err) {
                  console.log(err)
                }
                this.$router.push({ path: '/success', params: { sample: 'hi' } })
              } else if(res.response_code === 4) {
                this.$hidePageLoading()
                this.$Simplert.open({
                  title: 'Information',
                  message: `<div style="text-align: left; line-height: 20px;">
                            <p>${res.response_message}</p>
                          </div>`,
                  type: 'info',
                  useConfirmBtn: false,
                  customCloseBtnText: 'Ok',
                  disableOverlayClick: true
                })
                this.getCartPaymentDetails()
              }
            }.bind(this)).catch(function (err) {
              console.log('METHOD:saveRequest', err)
            })
      }catch(err){

      }
    },
    clearRequestSessions: function () {
      this.$localStorage.remove('location')
      this.$localStorage.remove('st')
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('sa')
      this.$localStorage.remove('step')
      this.$localStorage.remove('cou')
    }
  },
  created () {
    this.selectedLab = []
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl')
    }
    if (this.$localStorage.get('location')) {
      this.selectedLocality = this.$localStorage.get('location')
    }

    this.selectedProfileAndTest = []
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st')
    }

    this.activeAddress = []
    if (this.$localStorage.get('sa')) {
      this.activeAddress = this.$localStorage.get('sa')
      this.isAddressActiveId = this.$localStorage.get('sa').addressId
    }

    this.activeMembers = []
    if (this.$localStorage.get('sm')) {
      this.activeMembers = this.$localStorage.get('sm')
      if (this.$localStorage.get('sm').userId === undefined) {
        this.isMemberActiveId = this.$localStorage.get('sm').memberId
      } else {
        this.isMemberActiveId = this.$localStorage.get('sm').userId
      }
    }
    if (this.$localStorage.get('cou')) {
      this.isCouponApplied = true
      this.couponData = this.$localStorage.get('cou')
      if (this.$localStorage.get('cou').coupon_percentage > 0) {
        this.isSuccessCoupon = true
        this.couponError = this.$localStorage.get('cou').coupon_percentage + '% '
      } else {
        this.isSuccessCoupon = true
        this.couponError = 'Rs.' + this.$localStorage.get('cou').coupon_price + ' '
      }
    }
    this.getProfile()
    this.getTestCosts()
    this.getAddress()
    this.getMembers()
    this.searchLocation(this.$localStorage.get('pincode'))
    this.getCartPaymentDetails(true)
    let year = (new Date()).getFullYear()
    let endYear = year - 120
    for (let i = year; i > endYear; i--) {
      this.dobYears.push(i.toString())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Book/Secure/Address.vue